import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Input, Directive, EventEmitter, Output, ViewChild, Component, NgModule } from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import * as i6 from 'primeng/table';
import { Table, TableService, TableModule } from 'primeng/table';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import * as i19 from '@ezuiaws/ez.ui.packages/ez-pipes';
import { EzUncamelcasePipe, EzLongToDotsPipe } from '@ezuiaws/ez.ui.packages/ez-pipes';
import * as i18 from '@ezuiaws/ez.ui.packages/ez-localization';
import { ResourcesProvider, EzLocalizationModule } from '@ezuiaws/ez.ui.packages/ez-localization';
import { filter } from 'rxjs/operators';
import * as i1 from '@ezuiaws/ez.ui.packages/ez-layout';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i4 from '@ezuiaws/ez.ui.packages/ez-buttons';
import { EzButtonsModule } from '@ezuiaws/ez.ui.packages/ez-buttons';
import * as i5 from 'primeng/api';
import * as i7 from 'primeng/ripple';
import { RippleModule } from 'primeng/ripple';
import * as i8 from 'primeng/tooltip';
import { TooltipModule } from 'primeng/tooltip';
import * as i9 from 'primeng/multiselect';
import { MultiSelectModule } from 'primeng/multiselect';
import * as i10 from 'primeng/button';
import { ButtonModule } from 'primeng/button';
import * as i11 from 'primeng/inputtext';
import { InputTextModule } from 'primeng/inputtext';
import * as i12 from '@ezuiaws/ez.ui.packages/ez-tooltip';
import { EzTooltipComponent } from '@ezuiaws/ez.ui.packages/ez-tooltip';
import * as i13 from 'primeng/divider';
import { DividerModule } from 'primeng/divider';
import * as i14 from '@ezuiaws/ez.ui.packages/ez-directives';
import { EzSelectOverlayDirective, EzInputWidthByPlaceholderDirective } from '@ezuiaws/ez.ui.packages/ez-directives';
import * as i15 from 'primeng/select';
import { Select } from 'primeng/select';
import * as i7$1 from 'primeng/treetable';
import { TreeTable, TreeTableModule } from 'primeng/treetable';
import * as i4$1 from '@ezuiaws/ez.ui.packages/ez-checkbox';
import { EzCheckboxComponent } from '@ezuiaws/ez.ui.packages/ez-checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectButtonModule } from 'primeng/selectbutton';
const _c0 = ["dt"];
const _c1 = ["txtGlobalFilter"];
const _c2 = ["drpTableOptions"];
const _c3 = (a0, a1) => ({
  selectedRows: a0,
  editing: a1
});
const _c4 = () => ({
  appendTo: "body",
  styleClass: "ez-select-overlay-panel"
});
const _c5 = a0 => ({
  "two-buttons-more": a0
});
const _c6 = a0 => ({
  columns: a0
});
const _c7 = a0 => ({
  "after-reordable-icon": a0
});
const _c8 = a0 => ({
  "left": a0
});
const _c9 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13) => ({
  highlightRow: a0,
  highlightSuccess: a1,
  highlightPink: a2,
  highlightDanger: a3,
  highlightWarning: a4,
  highlightComplete: a5,
  highlightDisabled: a6,
  highlightInfo: a7,
  highlightTextBold: a8,
  highlightTextItalic: a9,
  highlightTextDisabled: a10,
  editRow: a11,
  cancelEditRow: a12,
  saveEditRow: a13
});
const _c10 = (a0, a1, a2) => ({
  rowData: a0,
  editing: a1,
  rowFns: a2
});
const _c11 = a0 => ({
  "no-hover": a0
});
const _c12 = (a0, a1, a2, a3) => ({
  rowData: a0,
  field: a1,
  editing: a2,
  rowFns: a3
});
const _c13 = (a0, a1, a2) => ({
  rowData: a0,
  field: a1,
  editing: a2
});
const _c14 = (a0, a1, a2) => ({
  rowData: a0,
  ezGrid: a1,
  ri: a2
});
const _c15 = a0 => ({
  "no-border": a0
});
const _c16 = (a0, a1) => ({
  "justify-content-start": a0,
  "justify-content-center": a1
});
const _c17 = () => ({
  appendTo: "body",
  styleClass: "ez-select-overlay-panel full-screen-dropdown"
});
const _c18 = (a0, a1) => ({
  "mt-3": a0,
  "mobile-border": a1
});
const _c19 = (a0, a1) => ({
  "mobile-search": a0,
  "d-none": a1
});
const _c20 = (a0, a1) => ({
  "close-2pt": a0,
  "search-2pt": a1
});
function EzTableComponent_ng_template_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.tableName, " ");
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-secondary-button", 31);
    i0.ɵɵpipe(1, "ezLocale");
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Conditional_2_Conditional_1_Template_ez_secondary_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r1.onActionApply());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(6);
    i0.ɵɵproperty("cyName", ctx_r1.tableNamePrefix + "-apply-actions-btn")("cssClass", "mr-2 ml-2 button-small")("disabled", ctx_r1.selectedAction === null)("label", i0.ɵɵpipeBind1(1, 4, "Apply"));
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 23)(1, EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Conditional_2_Conditional_1_Template, 2, 6, "ez-secondary-button", 30);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    const tableOptionsDropdown_r4 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngTemplateOutlet", tableOptionsDropdown_r4);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.enableActionApplyUponSelection ? 1 : -1);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-tableHeaderCheckbox", 28);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 29)(2, EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Conditional_2_Template, 2, 2);
  }
  if (rf & 2) {
    const editing_r5 = i0.ɵɵnextContext(3).editing;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r1.rowEdit || ctx_r1.tableActionsDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customTableActionsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(4, _c3, ctx_r1.selectedRows, editing_r5));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.customTableActionsTemplate ? 2 : -1);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 23);
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const searchAndFilterButtonConainer_r6 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", searchAndFilterButtonConainer_r6);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵtemplate(2, EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_2_Template, 3, 7)(3, EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Conditional_3_Template, 1, 1, "ng-container");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.selectionMode === "multiple" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isMobileDevice ? 3 : -1);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 32);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.tableName, " ");
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-button-icon", 33);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_2_ng_container_1_Conditional_7_Template_ez_button_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onRefreshTableClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("cssClass", "mr-2 button-icon-medium")("iconClass", "refresh-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-button-refresh");
  }
}
function EzTableComponent_ng_template_2_ng_container_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 34);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_2_ng_container_1_Conditional_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      i0.ɵɵnextContext(3);
      const dt_r9 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(dt_r9.exportCSV());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-button-export");
  }
}
function EzTableComponent_ng_template_2_ng_container_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-multiSelect", 35);
    i0.ɵɵpipe(1, "ezLocale");
    i0.ɵɵpipe(2, "ezLocale");
    i0.ɵɵtwoWayListener("ngModelChange", function EzTableComponent_ng_template_2_ng_container_1_Conditional_9_Template_p_multiSelect_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedColumns, $event) || (ctx_r1.selectedColumns = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onChange", function EzTableComponent_ng_template_2_ng_container_1_Conditional_9_Template_p_multiSelect_onChange_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSelectedColumnsChange($event.value));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedColumns);
    i0.ɵɵproperty("options", ctx_r1.cols)("selectedItemsLabel", i0.ɵɵpipeBind1(1, 6, "ShowHideColumns"))("placeholder", i0.ɵɵpipeBind1(2, 8, "ShowHideColumns"))("overlayOptions", i0.ɵɵpureFunction0(10, _c4));
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-multiselect-table-selected-columns");
  }
}
function EzTableComponent_ng_template_2_ng_container_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵtemplate(2, EzTableComponent_ng_template_2_ng_container_1_ng_container_2_Template, 4, 2, "ng-container", 18)(3, EzTableComponent_ng_template_2_ng_container_1_ng_container_3_Template, 3, 1, "ng-container", 18);
    i0.ɵɵelementStart(4, "div", 21)(5, "div", 22);
    i0.ɵɵtemplate(6, EzTableComponent_ng_template_2_ng_container_1_ng_container_6_Template, 1, 0, "ng-container", 23)(7, EzTableComponent_ng_template_2_ng_container_1_Conditional_7_Template, 1, 3, "ez-button-icon", 24)(8, EzTableComponent_ng_template_2_ng_container_1_Conditional_8_Template, 1, 1, "button", 25)(9, EzTableComponent_ng_template_2_ng_container_1_Conditional_9_Template, 3, 11, "p-multiSelect", 26)(10, EzTableComponent_ng_template_2_ng_container_1_ng_container_10_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode === "multiple" || ctx_r1.showGlobalSearchField || ctx_r1.customGlobalSearchFieldTemplate || ctx_r1.customSearchOptionsRightOfSearchTextBoxTemplate || ctx_r1.showAdditionalFiltersBlockToggleIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode !== "multiple" && ctx_r1.tableName && !ctx_r1.showGlobalSearchField && ctx_r1.showTableName);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerUpperRightIconsTemplate);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showRefreshIcon ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showExportToCsv ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showHiddenColumnSelector ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.tableToolboxTemplate);
  }
}
function EzTableComponent_ng_template_2_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const additionalFiltersBlockBelowSearchTextBox_r11 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", additionalFiltersBlockBelowSearchTextBox_r11);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_container_3_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const numberOfResultsContainer_r12 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", numberOfResultsContainer_r12);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(4);
    const numberOfResultsContainer_r12 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", numberOfResultsContainer_r12);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_secondary_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-secondary-button", 40);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_secondary_button_3_Template_ez_secondary_button_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.additionalSecondaryGridHeaderButtonClicked.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("cyName", ctx_r1.tableNamePrefix + "-" + ctx_r1.additionalSecondaryGridHeaderButtonCyName)("disabled", ctx_r1.additionalSecondaryGridHeaderButtonDisabled)("label", ctx_r1.additionalSecondaryGridHeaderButtonLabel);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_secondary_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-secondary-button", 40);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_secondary_button_4_Template_ez_secondary_button_click_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.secondaryGridHeaderButtonClicked.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("cyName", ctx_r1.tableNamePrefix + "-" + ctx_r1.secondaryGridHeaderButtonCyName)("disabled", ctx_r1.secondaryGridHeaderButtonDisabled)("label", ctx_r1.secondaryGridHeaderButtonLabel);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_primary_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-primary-button", 40);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_primary_button_5_Template_ez_primary_button_click_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.primaryGridHeaderbuttonClicked.emit());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("cyName", ctx_r1.tableNamePrefix + "-" + ctx_r1.primaryGridHeaderButtonCyName)("disabled", ctx_r1.primaryGridHeaderButtonDisabled)("label", ctx_r1.primaryGridHeaderButtonLabel);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ng_container_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(4);
    const numberOfResultsContainer_r12 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", numberOfResultsContainer_r12);
  }
}
function EzTableComponent_ng_template_2_ng_container_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 37);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ng_container_1_Template, 2, 1, "ng-container", 18);
    i0.ɵɵelementStart(2, "div", 38);
    i0.ɵɵtemplate(3, EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_secondary_button_3_Template, 1, 3, "ez-secondary-button", 39)(4, EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_secondary_button_4_Template, 1, 3, "ez-secondary-button", 39)(5, EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ez_primary_button_5_Template, 1, 3, "ez-primary-button", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, EzTableComponent_ng_template_2_ng_container_3_ng_template_2_ng_container_6_Template, 2, 1, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c5, ctx_r1.showPrimaryGridHeaderButton && (ctx_r1.showSecondaryGridHeaderButton || ctx_r1.showAdditionalSecondaryGridHeaderButton)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showPrimaryGridHeaderButton && !(ctx_r1.showSecondaryGridHeaderButton || ctx_r1.showAdditionalSecondaryGridHeaderButton));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showSecondaryGridHeaderButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showSecondaryGridHeaderButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showPrimaryGridHeaderButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showPrimaryGridHeaderButton && (ctx_r1.showSecondaryGridHeaderButton || ctx_r1.showAdditionalSecondaryGridHeaderButton));
  }
}
function EzTableComponent_ng_template_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_container_3_ng_container_1_Template, 2, 1, "ng-container", 36)(2, EzTableComponent_ng_template_2_ng_container_3_ng_template_2_Template, 7, 8, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const mobileDeviceGridHeader_r16 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isMobileDevice)("ngIfElse", mobileDeviceGridHeader_r16);
  }
}
function EzTableComponent_ng_template_2_ng_template_4_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_template_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_template_4_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const defaultSearchContainer_r17 = i0.ɵɵreference(16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultSearchContainer_r17);
  }
}
function EzTableComponent_ng_template_2_ng_template_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_template_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_template_4_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_2_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 41);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_2_ng_template_4_ng_container_1_Template, 2, 1, "ng-container", 18)(2, EzTableComponent_ng_template_2_ng_template_4_ng_container_2_Template, 1, 0, "ng-container", 23)(3, EzTableComponent_ng_template_2_ng_template_4_ng_container_3_Template, 1, 0, "ng-container", 29)(4, EzTableComponent_ng_template_2_ng_template_4_ng_container_4_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const editing_r5 = i0.ɵɵnextContext().editing;
    const ctx_r1 = i0.ɵɵnextContext();
    const additionalFiltersBlockToggleIcon_r18 = i0.ɵɵreference(12);
    i0.ɵɵproperty("ngClass", ctx_r1.selectionMode === "multiple" ? "justify-content-center" : "justify-content-end");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showGlobalSearchField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customGlobalSearchFieldTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customSearchOptionsRightOfSearchTextBoxTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(6, _c3, ctx_r1.selectedRows, editing_r5));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", additionalFiltersBlockToggleIcon_r18);
  }
}
function EzTableComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_ng_template_2_ng_container_0_Template, 3, 1, "ng-container", 18)(1, EzTableComponent_ng_template_2_ng_container_1_Template, 11, 7, "ng-container", 18)(2, EzTableComponent_ng_template_2_ng_container_2_Template, 2, 1, "ng-container", 18)(3, EzTableComponent_ng_template_2_ng_container_3_Template, 4, 2, "ng-container", 18)(4, EzTableComponent_ng_template_2_ng_template_4_Template, 5, 9, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.tableName && (ctx_r1.selectionMode === "multiple" || ctx_r1.showGlobalSearchField) && ctx_r1.showTableName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHeader && !ctx_r1.isMobileDevice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isMobileDevice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showNumberOfRows && ctx_r1._rows);
  }
}
function EzTableComponent_ng_template_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 46);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_3_p_tableHeaderCheckbox_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-tableHeaderCheckbox", 49);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", ctx_r1.isMobileDevice ? "ml-1" : "mr-2")("disabled", ctx_r1.rowEdit);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 47);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_3_ng_container_1_th_3_p_tableHeaderCheckbox_1_Template, 1, 2, "p-tableHeaderCheckbox", 48);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c7, ctx_r1._reorderableRows && !ctx_r1.colIsSorted))("ngStyle", i0.ɵɵpureFunction1(5, _c8, !(ctx_r1._reorderableRows && !ctx_r1.colIsSorted) ? "0" : "24px"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.showHeader || ctx_r1.isMobileDevice);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_ng_container_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.priorityColumnTitle, " ");
  }
}
function EzTableComponent_ng_template_3_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "th", 50);
    i0.ɵɵtemplate(2, EzTableComponent_ng_template_3_ng_container_1_ng_container_4_ng_container_2_Template, 2, 1, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.priorityColumnTitle.length > 0);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_5_p_sortIcon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-sortIcon", 55);
  }
  if (rf & 2) {
    const col_r19 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("field", col_r19.field);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 51)(1, "div", 52)(2, "span", 53);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, EzTableComponent_ng_template_3_ng_container_1_th_5_p_sortIcon_4_Template, 1, 1, "p-sortIcon", 54);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const col_r19 = ctx.$implicit;
    const colIndex_r20 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("p-resizable-column p-resizable-column-" + colIndex_r20);
    i0.ɵɵproperty("pSortableColumn", col_r19.field);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.replaceHeaderText(col_r19.field));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.enableSorting);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 56);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ez-button-icon", 57);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_3_ng_container_1_th_8_ng_container_1_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onAddItemClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("cssClass", "button-icon-medium")("iconClass", "add-rounded")("isSecondaryButton", true)("isIconOnly", true);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 56);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_3_ng_container_1_th_8_ng_container_1_Template, 2, 4, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showAdd);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 56);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_th_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 56);
  }
}
function EzTableComponent_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, EzTableComponent_ng_template_3_ng_container_1_th_2_Template, 1, 0, "th", 42)(3, EzTableComponent_ng_template_3_ng_container_1_th_3_Template, 2, 7, "th", 43)(4, EzTableComponent_ng_template_3_ng_container_1_ng_container_4_Template, 3, 1, "ng-container", 18)(5, EzTableComponent_ng_template_3_ng_container_1_th_5_Template, 5, 5, "th", 44)(6, EzTableComponent_ng_template_3_ng_container_1_th_6_Template, 1, 0, "th", 45)(7, EzTableComponent_ng_template_3_ng_container_1_ng_container_7_Template, 1, 0, "ng-container", 23)(8, EzTableComponent_ng_template_3_ng_container_1_th_8_Template, 2, 1, "th", 45)(9, EzTableComponent_ng_template_3_ng_container_1_th_9_Template, 1, 0, "th", 45)(10, EzTableComponent_ng_template_3_ng_container_1_th_10_Template, 1, 0, "th", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columns_r22 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._reorderableRows && !ctx_r1.colIsSorted && !ctx_r1.isMobileDevice && !ctx_r1.isTabletDevice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode !== null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._reorderableRows && !ctx_r1.colIsSorted && ctx_r1.orderArrowsAvailable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", columns_r22);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHiddenColumnInfo && ctx_r1.unSelectedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customActionsHeadersTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCopy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDelete);
  }
}
function EzTableComponent_ng_template_3_ng_container_2_th_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 62);
  }
}
function EzTableComponent_ng_template_3_ng_container_2_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 63);
  }
}
function EzTableComponent_ng_template_3_ng_container_2_th_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 64);
    i0.ɵɵpipe(1, "ezUncamelcase");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r23 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("pTooltip", i0.ɵɵpipeBind1(1, 3, col_r23.label));
    i0.ɵɵproperty("showDelay", 500);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", col_r23.label, " ");
  }
}
function EzTableComponent_ng_template_3_ng_container_2_th_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 65);
  }
}
function EzTableComponent_ng_template_3_ng_container_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_3_ng_container_2_th_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 65);
  }
}
function EzTableComponent_ng_template_3_ng_container_2_th_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 65);
  }
}
function EzTableComponent_ng_template_3_ng_container_2_th_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 65);
  }
}
function EzTableComponent_ng_template_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, EzTableComponent_ng_template_3_ng_container_2_th_2_Template, 1, 0, "th", 58)(3, EzTableComponent_ng_template_3_ng_container_2_th_3_Template, 1, 0, "th", 59)(4, EzTableComponent_ng_template_3_ng_container_2_th_4_Template, 3, 5, "th", 60)(5, EzTableComponent_ng_template_3_ng_container_2_th_5_Template, 1, 0, "th", 61)(6, EzTableComponent_ng_template_3_ng_container_2_ng_container_6_Template, 1, 0, "ng-container", 23)(7, EzTableComponent_ng_template_3_ng_container_2_th_7_Template, 1, 0, "th", 61)(8, EzTableComponent_ng_template_3_ng_container_2_th_8_Template, 1, 0, "th", 61)(9, EzTableComponent_ng_template_3_ng_container_2_th_9_Template, 1, 0, "th", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._reorderableRows && !ctx_r1.colIsSorted);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode !== null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHiddenColumnInfo && ctx_r1.unSelectedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customActionsHeadersTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCopy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDelete);
  }
}
function EzTableComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_ng_template_3_ng_container_0_Template, 1, 0, "ng-container", 29)(1, EzTableComponent_ng_template_3_ng_container_1_Template, 11, 9, "ng-container", 18)(2, EzTableComponent_ng_template_3_ng_container_2_Template, 10, 8, "ng-container", 18);
  }
  if (rf & 2) {
    const columns_r22 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customHeadersTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c6, columns_r22));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.customHeadersTemplate && !ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.columnList);
  }
}
function EzTableComponent_ng_template_4_tr_0_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 46);
    i0.ɵɵelement(1, "i", 70);
    i0.ɵɵelementEnd();
  }
}
function EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 77);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_span_1_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r24);
      const rowData_r25 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectedRow(rowData_r25));
    });
    i0.ɵɵtext(1, " Select ");
    i0.ɵɵelementEnd();
  }
}
function EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_p_tableRadioButton_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tableRadioButton", 78);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_p_tableRadioButton_2_Template_p_tableRadioButton_click_0_listener() {
      i0.ɵɵrestoreView(_r26);
      const rowData_r25 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectedRow(rowData_r25));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    const rowData_r25 = ctx_r26.$implicit;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", rowData_r25);
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("radio", rowData_r25, ri_r28));
  }
}
function EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_p_tableCheckbox_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-tableCheckbox", 79);
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(4);
    const rowData_r25 = ctx_r26.$implicit;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", rowData_r25)("disabled", ctx_r1.rowEdit || ctx_r1.tableActionsDisabled);
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("checkbox", rowData_r25, ri_r28));
  }
}
function EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 73);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_span_1_Template, 2, 0, "span", 74)(2, EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_p_tableRadioButton_2_Template, 1, 2, "p-tableRadioButton", 75)(3, EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_p_tableCheckbox_3_Template, 1, 3, "p-tableCheckbox", 76);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngSwitch", ctx_r1.selectionMode);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "single");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "radio");
  }
}
function EzTableComponent_ng_template_4_tr_0_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 71);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_td_3_ng_container_1_Template, 4, 3, "ng-container", 72);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const editing_r29 = i0.ɵɵnextContext(2).editing;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !editing_r29);
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "td", 80)(2, "div", 81)(3, "div", 82)(4, "i", 83);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_ng_container_4_Template_i_click_4_listener() {
      i0.ɵɵrestoreView(_r30);
      const ri_r28 = i0.ɵɵnextContext(2).rowIndex;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRowReorderByClick(ri_r28, false));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "i", 84);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_ng_container_4_Template_i_click_5_listener() {
      i0.ɵɵrestoreView(_r30);
      const ri_r28 = i0.ɵɵnextContext(2).rowIndex;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onRowReorderByClick(ri_r28, true));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "span", 85);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    const rowData_r25 = ctx_r26.$implicit;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    const dt_r9 = i0.ɵɵreference(1);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c11, ri_r28 - dt_r9.first === 0 || ctx_r1._rows.length === 1));
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("order-button", rowData_r25, ri_r28));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c11, ri_r28 - dt_r9.first === (ctx_r1._rows.length - dt_r9.first < dt_r9.rows ? ctx_r1._rows.length - dt_r9.first - 1 : dt_r9.rows - 1) || ctx_r1._rows.length === 1));
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("order-button", rowData_r25, ri_r28));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ri_r28 + 1, " ");
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_5_td_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_5_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 73);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_ng_container_5_td_1_ng_container_1_Template, 1, 0, "ng-container", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r31 = ctx.$implicit;
    const colIndex_r32 = ctx.index;
    i0.ɵɵnextContext(2);
    const ezRow_r33 = i0.ɵɵreference(1);
    const ctx_r26 = i0.ɵɵnextContext();
    const rowData_r25 = ctx_r26.$implicit;
    const editing_r29 = ctx_r26.editing;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("p-resizable-column p-resizable-column-" + colIndex_r32);
    i0.ɵɵproperty("ngSwitch", col_r31.field);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.columnsOutput)("ngTemplateOutletContext", i0.ɵɵpureFunction4(20, _c12, rowData_r25, col_r31.field, editing_r29, i0.ɵɵpureFunctionV(5, _c9, [ctx_r1.highlightThisRow(ezRow_r33), ctx_r1.highlightIf(ezRow_r33, "bg-success"), ctx_r1.highlightIf(ezRow_r33, "bg-pink"), ctx_r1.highlightIf(ezRow_r33, "bg-danger"), ctx_r1.highlightIf(ezRow_r33, "bg-warning"), ctx_r1.highlightIf(ezRow_r33, "bg-complete"), ctx_r1.highlightIf(ezRow_r33, "bg-disabled"), ctx_r1.highlightIf(ezRow_r33, "bg-info"), ctx_r1.highlightIf(ezRow_r33, "font-weight-bold"), ctx_r1.highlightIf(ezRow_r33, "font-italic"), ctx_r1.highlightIf(ezRow_r33, "text-secondary"), ctx_r1.editRow(rowData_r25), ctx_r1.cancelEditRow(ri_r28), ctx_r1.saveEditRow(rowData_r25, ri_r28)])));
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_ng_container_5_td_1_Template, 2, 25, "td", 86);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columns_r34 = i0.ɵɵnextContext(2).columns;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", columns_r34);
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_6_td_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_6_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 88);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_ng_container_6_td_1_ng_container_1_Template, 1, 0, "ng-container", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r35 = ctx.$implicit;
    const ctx_r26 = i0.ɵɵnextContext(3);
    const rowData_r25 = ctx_r26.$implicit;
    const editing_r29 = ctx_r26.editing;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", col_r35.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.columnsOutput)("ngTemplateOutletContext", i0.ɵɵpureFunction3(3, _c13, rowData_r25, col_r35.value, editing_r29));
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_ng_container_6_td_1_Template, 2, 7, "td", 87);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.columnList);
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_4_tr_0_td_8_span_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 93);
    i0.ɵɵpipe(1, "ezLongToDots");
  }
  if (rf & 2) {
    const col_r36 = ctx.$implicit;
    const rowData_r25 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.outputUnselectedColumnData(rowData_r25, col_r36), 300), i0.ɵɵsanitizeHtml);
  }
}
function EzTableComponent_ng_template_4_tr_0_td_8_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 90)(1, "ez-tooltip", 91);
    i0.ɵɵtemplate(2, EzTableComponent_ng_template_4_tr_0_td_8_span_1_div_2_Template, 2, 4, "div", 92);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hasCustomizedContent", true)("tooltipPosition", "top-left");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.unSelectedColumns);
  }
}
function EzTableComponent_ng_template_4_tr_0_td_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 65);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_td_8_span_1_Template, 3, 3, "span", 89);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rowData_r25 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hiddenInfoColumnHasData(rowData_r25));
  }
}
function EzTableComponent_ng_template_4_tr_0_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_4_tr_0_td_10_ez_button_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-button-icon", 96);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_td_10_ez_button_icon_1_Template_ez_button_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r37);
      const rowData_r25 = i0.ɵɵnextContext(3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEdit(rowData_r25));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    const rowData_r25 = ctx_r26.$implicit;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isSecondaryButton", true)("isIconOnly", true)("cssClass", "button-icon-medium")("iconClass", "edit-2pt")("disabled", ctx_r1.showDisabledEditIcon);
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r25, ri_r28));
  }
}
function EzTableComponent_ng_template_4_tr_0_td_10_ez_button_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-button-icon", 97);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_td_10_ez_button_icon_2_Template_ez_button_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r38);
      const ri_r28 = i0.ɵɵnextContext(3).rowIndex;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEditCancel(ri_r28));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    const rowData_r25 = ctx_r26.$implicit;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isSecondaryButton", true)("isIconOnly", true)("cssClass", "button-icon-medium")("iconClass", "undo-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r25, ri_r28));
  }
}
function EzTableComponent_ng_template_4_tr_0_td_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 56);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_td_10_ez_button_icon_1_Template, 1, 6, "ez-button-icon", 94)(2, EzTableComponent_ng_template_4_tr_0_td_10_ez_button_icon_2_Template, 1, 5, "ez-button-icon", 95);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const editing_r29 = i0.ɵɵnextContext(2).editing;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !editing_r29);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", editing_r29);
  }
}
function EzTableComponent_ng_template_4_tr_0_td_11_ez_button_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-button-icon", 99);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_td_11_ez_button_icon_1_Template_ez_button_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r39);
      const ctx_r26 = i0.ɵɵnextContext(3);
      const rowData_r25 = ctx_r26.$implicit;
      const ri_r28 = ctx_r26.rowIndex;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEditSave(rowData_r25, ri_r28));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(3);
    const rowData_r25 = ctx_r26.$implicit;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isSecondaryButton", true)("isIconOnly", true)("cssClass", "button-icon-medium")("iconClass", "check-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r25, ri_r28));
  }
}
function EzTableComponent_ng_template_4_tr_0_td_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 56);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_4_tr_0_td_11_ez_button_icon_1_Template, 1, 5, "ez-button-icon", 98);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const editing_r29 = i0.ɵɵnextContext(2).editing;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", editing_r29);
  }
}
function EzTableComponent_ng_template_4_tr_0_td_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 56)(1, "ez-button-icon", 100);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_td_12_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r40);
      const rowData_r25 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCopyRow(rowData_r25));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    const rowData_r25 = ctx_r26.$implicit;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("isSecondaryButton", true)("isIconOnly", true)("cssClass", "button-icon-medium")("iconClass", "duplicate-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r25, ri_r28));
  }
}
function EzTableComponent_ng_template_4_tr_0_td_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 56)(1, "ez-button-icon", 101);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_4_tr_0_td_13_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r41);
      const rowData_r25 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDelete(rowData_r25));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    const rowData_r25 = ctx_r26.$implicit;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cssClass", "button-icon-medium")("isSecondaryButton", true)("isIconOnly", true)("iconClass", "delete-2pt")("disabled", ctx_r1.showDisabledDeleteIcon);
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r25, ri_r28));
  }
}
function EzTableComponent_ng_template_4_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 68, 8);
    i0.ɵɵtemplate(2, EzTableComponent_ng_template_4_tr_0_td_2_Template, 2, 0, "td", 42)(3, EzTableComponent_ng_template_4_tr_0_td_3_Template, 2, 1, "td", 69)(4, EzTableComponent_ng_template_4_tr_0_ng_container_4_Template, 8, 9, "ng-container", 18)(5, EzTableComponent_ng_template_4_tr_0_ng_container_5_Template, 2, 1, "ng-container", 18)(6, EzTableComponent_ng_template_4_tr_0_ng_container_6_Template, 2, 1, "ng-container", 18)(7, EzTableComponent_ng_template_4_tr_0_ng_container_7_Template, 1, 0, "ng-container", 29)(8, EzTableComponent_ng_template_4_tr_0_td_8_Template, 2, 1, "td", 61)(9, EzTableComponent_ng_template_4_tr_0_ng_container_9_Template, 1, 0, "ng-container", 29)(10, EzTableComponent_ng_template_4_tr_0_td_10_Template, 3, 2, "td", 45)(11, EzTableComponent_ng_template_4_tr_0_td_11_Template, 2, 1, "td", 45)(12, EzTableComponent_ng_template_4_tr_0_td_12_Template, 2, 5, "td", 45)(13, EzTableComponent_ng_template_4_tr_0_td_13_Template, 2, 6, "td", 45);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ezRow_r33 = i0.ɵɵreference(1);
    const ctx_r26 = i0.ɵɵnextContext();
    const rowData_r25 = ctx_r26.$implicit;
    const editing_r29 = ctx_r26.editing;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("pEditableRow", rowData_r25)("pReorderableRow", ctx_r1._reorderableRows ? ri_r28 : "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._reorderableRows && !ctx_r1.colIsSorted && !ctx_r1.isMobileDevice && !ctx_r1.isTabletDevice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode !== null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._reorderableRows && !ctx_r1.colIsSorted && ctx_r1.orderArrowsAvailable);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.customColumnsTemplate && !ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customColumnsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(31, _c10, rowData_r25, editing_r29, i0.ɵɵpureFunctionV(16, _c9, [ctx_r1.highlightThisRow(ezRow_r33), ctx_r1.highlightIf(ezRow_r33, "bg-success"), ctx_r1.highlightIf(ezRow_r33, "bg-pink"), ctx_r1.highlightIf(ezRow_r33, "bg-danger"), ctx_r1.highlightIf(ezRow_r33, "bg-warning"), ctx_r1.highlightIf(ezRow_r33, "bg-complete"), ctx_r1.highlightIf(ezRow_r33, "bg-disabled"), ctx_r1.highlightIf(ezRow_r33, "bg-info"), ctx_r1.highlightIf(ezRow_r33, "font-weight-bold"), ctx_r1.highlightIf(ezRow_r33, "font-italic"), ctx_r1.highlightIf(ezRow_r33, "text-secondary"), ctx_r1.editRow(rowData_r25), ctx_r1.cancelEditRow(ri_r28), ctx_r1.saveEditRow(rowData_r25, ri_r28)])));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHiddenColumnInfo && ctx_r1.unSelectedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customActionsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(50, _c10, rowData_r25, editing_r29, i0.ɵɵpureFunctionV(35, _c9, [ctx_r1.highlightThisRow(ezRow_r33), ctx_r1.highlightIf(ezRow_r33, "bg-success"), ctx_r1.highlightIf(ezRow_r33, "bg-pink"), ctx_r1.highlightIf(ezRow_r33, "bg-danger"), ctx_r1.highlightIf(ezRow_r33, "bg-warning"), ctx_r1.highlightIf(ezRow_r33, "bg-complete"), ctx_r1.highlightIf(ezRow_r33, "bg-disabled"), ctx_r1.highlightIf(ezRow_r33, "bg-info"), ctx_r1.highlightIf(ezRow_r33, "font-weight-bold"), ctx_r1.highlightIf(ezRow_r33, "font-italic"), ctx_r1.highlightIf(ezRow_r33, "text-secondary"), ctx_r1.editRow(rowData_r25), ctx_r1.cancelEditRow(ri_r28), ctx_r1.saveEditRow(rowData_r25, ri_r28)])));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", editing_r29 && ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCopy && !editing_r29);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDelete && !editing_r29);
  }
}
function EzTableComponent_ng_template_4_tr_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_4_tr_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 102)(1, "td", 103);
    i0.ɵɵtemplate(2, EzTableComponent_ng_template_4_tr_1_ng_container_2_Template, 1, 0, "ng-container", 29);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext();
    const rowData_r25 = ctx_r26.$implicit;
    const columns_r34 = ctx_r26.columns;
    const ri_r28 = ctx_r26.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("pEditableRow", rowData_r25);
    i0.ɵɵadvance();
    i0.ɵɵproperty("colSpan", columns_r34.length + 3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.editTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(4, _c14, rowData_r25, ctx_r1, ri_r28));
  }
}
function EzTableComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_ng_template_4_tr_0_Template, 14, 54, "tr", 66)(1, EzTableComponent_ng_template_4_tr_1_Template, 3, 8, "tr", 67);
  }
  if (rf & 2) {
    const editing_r29 = ctx.editing;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", (editing_r29 && !ctx_r1.hasEditTemplate || !editing_r29) && !ctx_r1.customColumnsTemplateNoRow);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", editing_r29 && ctx_r1.hasEditTemplate && !ctx_r1.customColumnsTemplateNoRow);
  }
}
function EzTableComponent_ng_template_5_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_5_ng_container_0_Conditional_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_5_ng_container_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_ng_template_5_ng_container_0_Conditional_3_ng_container_0_Template, 1, 0, "ng-container", 29);
  }
  if (rf & 2) {
    const columns_r42 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customEmptyMessageTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, columns_r42));
  }
}
function EzTableComponent_ng_template_5_ng_container_0_td_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const columns_r42 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("colspan", columns_r42 && columns_r42.length ? columns_r42.length : 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.emptymessage, " ");
  }
}
function EzTableComponent_ng_template_5_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_5_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 29);
    i0.ɵɵelementStart(2, "tr");
    i0.ɵɵtemplate(3, EzTableComponent_ng_template_5_ng_container_0_Conditional_3_Template, 1, 4, "ng-container")(4, EzTableComponent_ng_template_5_ng_container_0_td_4_Template, 2, 2, "td", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columns_r42 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customEmptyMessageTemplateNoRow)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c6, columns_r42));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.customEmptyMessageTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.customEmptyMessageTemplate && !ctx_r1.customEmptyMessageTemplateNoRow);
  }
}
function EzTableComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_ng_template_5_ng_container_0_Template, 5, 6, "ng-container", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.showNumberOfRows);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 62);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 63);
    i0.ɵɵtext(1, " Totals ");
    i0.ɵɵelementEnd();
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_ng_container_4_td_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r43 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getColumnTotal(col_r43.label));
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_ng_container_4_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, EzTableComponent_6_ng_template_0_ng_container_0_ng_container_4_td_1_span_1_Template, 2, 1, "span", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r43 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isTotalColumn(col_r43.label));
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_6_ng_template_0_ng_container_0_ng_container_4_td_1_Template, 2, 1, "td", 105);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.columnList);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_ng_container_5_td_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r44 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getColumnTotal(col_r44.field));
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_ng_container_5_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, EzTableComponent_6_ng_template_0_ng_container_0_ng_container_5_td_1_span_1_Template, 2, 1, "span", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r44 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isTotalColumn(col_r44.field));
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableComponent_6_ng_template_0_ng_container_0_ng_container_5_td_1_Template, 2, 1, "td", 105);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columns_r45 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", columns_r45);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_td_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 65);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_td_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 65);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_td_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 65);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_td_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 65);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, EzTableComponent_6_ng_template_0_ng_container_0_td_2_Template, 1, 0, "td", 58)(3, EzTableComponent_6_ng_template_0_ng_container_0_td_3_Template, 2, 0, "td", 59)(4, EzTableComponent_6_ng_template_0_ng_container_0_ng_container_4_Template, 2, 1, "ng-container", 18)(5, EzTableComponent_6_ng_template_0_ng_container_0_ng_container_5_Template, 2, 1, "ng-container", 18)(6, EzTableComponent_6_ng_template_0_ng_container_0_td_6_Template, 1, 0, "td", 61)(7, EzTableComponent_6_ng_template_0_ng_container_0_td_7_Template, 1, 0, "td", 61)(8, EzTableComponent_6_ng_template_0_ng_container_0_td_8_Template, 1, 0, "td", 61)(9, EzTableComponent_6_ng_template_0_ng_container_0_td_9_Template, 1, 0, "td", 61);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1._reorderableRows && !ctx_r1.colIsSorted);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode !== null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHiddenColumnInfo && ctx_r1.unSelectedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCopy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDelete);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 107)(2, "ez-button-icon", 108);
    i0.ɵɵlistener("click", function EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_Template_ez_button_icon_click_2_listener() {
      i0.ɵɵrestoreView(_r46);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onSwitchToMainFooterClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_ng_container_3_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementStart(4, "ez-button-icon", 109);
    i0.ɵɵlistener("click", function EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_Template_ez_button_icon_click_4_listener() {
      i0.ɵɵrestoreView(_r46);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onSearchIconClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_ng_container_5_Template, 1, 0, "ng-container", 23)(6, EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_ng_container_6_Template, 1, 0, "ng-container", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    const tableOptionsDropdown_r4 = i0.ɵɵreference(10);
    const additionalFiltersBlockToggleIcon_r18 = i0.ɵɵreference(12);
    const defaultSearchContainer_r17 = i0.ɵɵreference(16);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cssClass", "button-icon-medium mobile-table-footer-button")("iconClass", "menu-vertical")("isIconOnly", true)("isSecondaryButton", true);
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-button-switch-to-main-footer");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tableOptionsDropdown_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cssClass", "button-icon-medium mobile-table-footer-button")("iconClass", "search-2pt")("isPrimaryButton", false)("isIconOnly", ctx_r1.isMobileDevice)("isSecondaryButton", !ctx_r1.showMobileSearchContainer)("isActiveButton", ctx_r1.showMobileSearchContainer);
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-button-toggle-search-container");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", defaultSearchContainer_r17);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", additionalFiltersBlockToggleIcon_r18);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 106);
    i0.ɵɵtemplate(2, EzTableComponent_6_ng_template_0_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 23)(3, EzTableComponent_6_ng_template_0_ng_container_1_ng_container_3_Template, 7, 15, "ng-container", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    const additionalFiltersBlockBelowSearchTextBox_r11 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c15, ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox || ctx_r1.optionsSelectionIsActive || ctx_r1.showMobileSearchContainer));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", additionalFiltersBlockBelowSearchTextBox_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.showCustomMobileTableFooterActionsTemplate)("ngIfElse", ctx_r1.customMobileTableFooterActionsTemplate);
  }
}
function EzTableComponent_6_ng_template_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_6_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_6_ng_template_0_ng_container_0_Template, 10, 8, "ng-container", 18)(1, EzTableComponent_6_ng_template_0_ng_container_1_Template, 4, 6, "ng-container", 18)(2, EzTableComponent_6_ng_template_0_ng_container_2_Template, 1, 0, "ng-container", 29);
  }
  if (rf & 2) {
    const columns_r45 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.customHeadersTemplate && ctx_r1.showFooterTotals);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isMobileDevice);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c6, columns_r45));
  }
}
function EzTableComponent_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_6_ng_template_0_Template, 3, 6, "ng-template", 104);
  }
}
function EzTableComponent_ng_template_7_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 112);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_7_ng_container_1_ng_container_4_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r47);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onClearFilters());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ezLocale");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-cy", "clear-filters-button");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "ClearFilters"), " ");
  }
}
function EzTableComponent_ng_template_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 111);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ezLocale");
    i0.ɵɵtemplate(4, EzTableComponent_ng_template_7_ng_container_1_ng_container_4_Template, 4, 4, "ng-container", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_11_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.isMobileDevice ? "mt-0 text-heading-4" : "text-heading-2");
    i0.ɵɵattribute("data-cy", "found-results-table-header");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 4, "FoundNumberOfResults", (tmp_11_0 = ctx_r1.numberOfFilteredRows) !== null && tmp_11_0 !== undefined ? tmp_11_0 : ctx_r1._rows.length), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showClearFilters && ctx_r1.filtersApplied);
  }
}
function EzTableComponent_ng_template_7_ng_template_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 112);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_7_ng_template_2_ng_container_4_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r48);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSelectAllRows(ctx_r1._rows));
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ezLocale");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-cy", "select-all-results-table-header");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(3, 2, "SelectAllNumberOfResults", ctx_r1._rows.length));
  }
}
function EzTableComponent_ng_template_7_ng_template_2_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 112);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_7_ng_template_2_ng_template_5_Template_span_click_0_listener() {
      i0.ɵɵrestoreView(_r49);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onClearSelection());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "ezLocale");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵattribute("data-cy", "clear-selection-results-table-header");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "ClearSelection"), "");
  }
}
function EzTableComponent_ng_template_7_ng_template_2_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r50 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 114);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ezLocale");
    i0.ɵɵpipe(4, "lowercase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 115);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_7_ng_template_2_ng_container_7_Template_span_click_5_listener() {
      i0.ɵɵrestoreView(_r50);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onClearFilters());
    });
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "ezLocale");
    i0.ɵɵpipe(8, "lowercase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 5, i0.ɵɵpipeBind1(3, 3, "Or")));
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("data-cy", "clear-filters-button");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, i0.ɵɵpipeBind1(7, 7, "ClearFilters")), "");
  }
}
function EzTableComponent_ng_template_7_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 113)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ezLocale");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, EzTableComponent_ng_template_7_ng_template_2_ng_container_4_Template, 4, 5, "ng-container", 36)(5, EzTableComponent_ng_template_7_ng_template_2_ng_template_5_Template, 3, 4, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor)(7, EzTableComponent_ng_template_7_ng_template_2_ng_container_7_Template, 9, 11, "ng-container", 18);
    i0.ɵɵelementStart(8, "span");
    i0.ɵɵtext(9, ".");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const clearSelection_r51 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.isMobileDevice ? "mt-0 text-heading-4" : "text-heading-2");
    i0.ɵɵattribute("data-cy", "selected-results-table-header");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(3, 6, "NumberOfResultsSelected", ctx_r1.selectedRows.length), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedRows.length < ctx_r1._rows.length && ctx_r1.selectedRows.length !== ctx_r1._rows.length)("ngIfElse", clearSelection_r51);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.showClearFilters && ctx_r1.filtersApplied);
  }
}
function EzTableComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 110);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_7_ng_container_1_Template, 5, 7, "ng-container", 36)(2, EzTableComponent_ng_template_7_ng_template_2_Template, 10, 9, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const numberOfSelectedRows_r52 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c16, ctx_r1.showPrimaryGridHeaderButton, !ctx_r1.showPrimaryGridHeaderButton));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.selectedRows || !(ctx_r1.selectedRows == null ? null : ctx_r1.selectedRows.length) || ctx_r1.searchText)("ngIfElse", numberOfSelectedRows_r52);
  }
}
function EzTableComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r53 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-select", 116, 11);
    i0.ɵɵpipe(2, "ezLocale");
    i0.ɵɵtwoWayListener("ngModelChange", function EzTableComponent_ng_template_9_Template_p_select_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedAction, $event) || (ctx_r1.selectedAction = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onChange", function EzTableComponent_ng_template_9_Template_p_select_onChange_0_listener($event) {
      i0.ɵɵrestoreView(_r53);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onActionSelected($event));
    })("onShow", function EzTableComponent_ng_template_9_Template_p_select_onShow_0_listener() {
      i0.ɵɵrestoreView(_r53);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleOptionsSelectionStatus());
    })("onHide", function EzTableComponent_ng_template_9_Template_p_select_onHide_0_listener() {
      i0.ɵɵrestoreView(_r53);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleOptionsSelectionStatus());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("options", ctx_r1._tableActions)("disabled", ctx_r1.tableActionsDisabled || !ctx_r1.selectedRows || !ctx_r1.selectedRows.length)("showClear", !ctx_r1.enableActionApplyUponSelection);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedAction);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(2, 8, "SelectAction"))("overlayOptions", i0.ɵɵpureFunction0(10, _c17))("addCloseButton", ctx_r1.isMobileDevice);
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-actions");
  }
}
function EzTableComponent_ng_template_11_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ez-button-icon", 117);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_11_ng_container_0_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r54);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAdditionalFiltersBlockToggleIconClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cyName", ctx_r1.tableNamePrefix + "-show-filters-btn")("cssClass", "button-icon-medium " + (!ctx_r1.isMobileDevice ? "mr-2" : "mobile-table-footer-button"))("iconClass", "filter-2pt")("isPrimaryButton", false)("isIconOnly", ctx_r1.isMobileDevice)("isSecondaryButton", !ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox)("isActiveButton", ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox);
  }
}
function EzTableComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableComponent_ng_template_11_ng_container_0_Template, 2, 7, "ng-container", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.showAdditionalFiltersBlockToggleIcon);
  }
}
function EzTableComponent_ng_template_13_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableComponent_ng_template_13_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "p-divider", 119);
    i0.ɵɵelementContainerEnd();
  }
}
function EzTableComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 118);
    i0.ɵɵtemplate(1, EzTableComponent_ng_template_13_ng_container_1_Template, 1, 0, "ng-container", 23)(2, EzTableComponent_ng_template_13_ng_container_2_Template, 2, 0, "ng-container", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox)("ngClass", i0.ɵɵpureFunction2(4, _c18, ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox && !ctx_r1.isMobileDevice, ctx_r1.isMobileDevice));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.additionalFiltersBlockBelowSearchTextBoxTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isMobileDevice);
  }
}
function EzTableComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 120)(1, "i", 121);
    i0.ɵɵlistener("click", function EzTableComponent_ng_template_15_Template_i_click_1_listener() {
      i0.ɵɵrestoreView(_r55);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clearGlobalSearch());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "input", 122, 12);
    i0.ɵɵlistener("input", function EzTableComponent_ng_template_15_Template_input_input_2_listener($event) {
      i0.ɵɵrestoreView(_r55);
      const ctx_r1 = i0.ɵɵnextContext();
      const dt_r9 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(ctx_r1.globalFilter($event.target, dt_r9));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c19, ctx_r1.isMobileDevice, !ctx_r1.showMobileSearchContainer && ctx_r1.isMobileDevice));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c20, ctx_r1.searchText.length > 0, ctx_r1.searchText.length === 0));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", ctx_r1.globalFilterPlaceholderText);
    i0.ɵɵproperty("placeholder", ctx_r1.globalFilterPlaceholderText);
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-global-filter");
  }
}
const _c21 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12) => ({
  highlightRow: a0,
  highlightSuccess: a1,
  highlightPink: a2,
  highlightDanger: a3,
  highlightWarning: a4,
  highlightComplete: a5,
  highlightInfo: a6,
  highlightTextBold: a7,
  highlightTextItalic: a8,
  highlightTextDisabled: a9,
  editRow: a10,
  cancelEditRow: a11,
  saveEditRow: a12
});
const _c22 = a0 => ({
  "d-flex": a0
});
const _c23 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16) => ({
  highlightRow: a0,
  highlightSuccess: a1,
  highlightPink: a2,
  highlightDanger: a3,
  highlightWarning: a4,
  highlightComplete: a5,
  highlightInfo: a6,
  highlightTextBold: a7,
  highlightTextItalic: a8,
  highlightTextDisabled: a9,
  addParentRowClass: a10,
  addChildRowClass: a11,
  addEmptyRowClass: a12,
  editRow: a13,
  cancelEditRow: a14,
  saveEditRow: a15,
  hideEdit: a16
});
const _c24 = a0 => ({
  "mt-3": a0
});
function EzTableTreeComponent_ng_template_2_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "h3", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.tableName);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "p-treeTableHeaderCheckbox", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", "mr-2");
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ez-checkbox", 24);
    i0.ɵɵlistener("valueChanged", function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_4_Template_ez_checkbox_valueChanged_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onEZCheckboxHeaderSelect($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("binary", true);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ez-secondary-button", 26);
    i0.ɵɵpipe(2, "ezLocale");
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_2_ng_container_4_Template_ez_secondary_button_click_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.onActionApply());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cyName", ctx_r1.tableNamePrefix + "-apply-actions-btn")("cssClass", "button-small mr-2 ml-2")("disabled", ctx_r1.selectedAction === null)("label", i0.ɵɵpipeBind1(2, 4, "Apply"));
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p-select", 25, 3);
    i0.ɵɵpipe(3, "ezLocale");
    i0.ɵɵtwoWayListener("ngModelChange", function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_2_Template_p_select_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedAction, $event) || (ctx_r1.selectedAction = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onChange", function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_2_Template_p_select_onChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onActionSelected($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_2_ng_container_4_Template, 3, 6, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("options", ctx_r1._tableActions)("disabled", ctx_r1.tableActionsDisabled || ctx_r1.selectedRows.length === 0);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedAction);
    i0.ɵɵproperty("placeholder", i0.ɵɵpipeBind1(3, 7, "SelectAction"))("overlayOptions", i0.ɵɵpureFunction0(9, _c4));
    i0.ɵɵattribute("data-cy", ctx_r1.tableName + "_TableActions");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.enableActionApplyUponSelection);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 19)(2, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_ng_container_2_Template, 5, 10, "ng-container", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const editing_r6 = i0.ɵɵnextContext(2).editing;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customTableActionsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(3, _c3, ctx_r1.selectedRows, editing_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.customTableActionsTemplate);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span", 27);
    i0.ɵɵelement(2, "i", 28);
    i0.ɵɵelementStart(3, "input", 29, 4);
    i0.ɵɵlistener("input", function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_7_Template_input_input_3_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      const dt_r8 = i0.ɵɵreference(1);
      return i0.ɵɵresetView(ctx_r1.globalFilter($event.target, dt_r8));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", ctx_r1.globalFilterPlaceholderText);
    i0.ɵɵproperty("placeholder", ctx_r1.globalFilterPlaceholderText);
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-global-filter");
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ez-button-icon", 30);
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_9_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onAdditionalFiltersBlockToggleIconClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cyName", ctx_r1.tableNamePrefix + "-show-filters-btn")("cssClass", "mr-2 button-icon-medium")("iconClass", "filter-2pt")("isPrimaryButton", false)("isSecondaryButton", !ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox)("isActiveButton", ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h3", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.tableName);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ez-button-icon", 32);
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_15_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onRefreshTableClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("cssClass", "mr-2 button-icon-medium")("iconClass", "refresh-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-button-refresh");
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-multiSelect", 33);
    i0.ɵɵpipe(1, "ezLocale");
    i0.ɵɵpipe(2, "ezLocale");
    i0.ɵɵtwoWayListener("ngModelChange", function EzTableTreeComponent_ng_template_2_ng_container_1_Conditional_16_Template_p_multiSelect_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedColumns, $event) || (ctx_r1.selectedColumns = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("onChange", function EzTableTreeComponent_ng_template_2_ng_container_1_Conditional_16_Template_p_multiSelect_onChange_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onSelectedColumnsChange($event.value));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedColumns);
    i0.ɵɵproperty("options", ctx_r1.cols)("selectedItemsLabel", i0.ɵɵpipeBind1(1, 6, "ShowHideColumns"))("placeholder", i0.ɵɵpipeBind1(2, 8, "ShowHideColumns"))("overlayOptions", i0.ɵɵpureFunction0(10, _c4));
    i0.ɵɵattribute("data-cy", ctx_r1.tableNamePrefix + "-multiselect-table-selected-columns");
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 16)(2, "div", 17);
    i0.ɵɵtemplate(3, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_3_Template, 2, 1, "ng-container", 10)(4, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_4_Template, 2, 1, "ng-container", 10)(5, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_5_Template, 3, 6, "ng-container", 10);
    i0.ɵɵelementStart(6, "div", 18);
    i0.ɵɵtemplate(7, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_7_Template, 5, 3, "ng-container", 10)(8, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_8_Template, 1, 0, "ng-container", 19)(9, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_9_Template, 2, 6, "ng-container", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_10_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_11_Template, 3, 1, "ng-container", 10);
    i0.ɵɵelementStart(12, "div", 20)(13, "div", 21);
    i0.ɵɵtemplate(14, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_14_Template, 1, 0, "ng-container", 13)(15, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_15_Template, 2, 3, "ng-container", 10)(16, EzTableTreeComponent_ng_template_2_ng_container_1_Conditional_16_Template, 3, 11, "p-multiSelect", 22)(17, EzTableTreeComponent_ng_template_2_ng_container_1_ng_container_17_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const editing_r6 = i0.ɵɵnextContext().editing;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode === "checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode === "ez-checkbox");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode !== "single");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showGlobalSearchField);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customSearchOptionsRightOfSearchTextBoxTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(14, _c3, ctx_r1.selectedRows, editing_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showAdditionalFiltersBlockToggleIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customSearchOptionsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(17, _c3, ctx_r1.selectedRows, editing_r6));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode !== "checkbox" && ctx_r1.tableName && !ctx_r1.showGlobalSearchField);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerUpperRightIconsTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showRefreshIcon);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showHiddenColumnSelector ? 16 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.tableToolboxTemplate);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableTreeComponent_ng_template_2_div_0_Template, 3, 1, "div", 12)(1, EzTableTreeComponent_ng_template_2_ng_container_1_Template, 18, 20, "ng-container", 10);
    i0.ɵɵelementContainerStart(2);
    i0.ɵɵtemplate(3, EzTableTreeComponent_ng_template_2_ng_container_3_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(4);
    i0.ɵɵtemplate(5, EzTableTreeComponent_ng_template_2_ng_container_5_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const additionalFiltersBlockBelowSearchTextBox_r12 = i0.ɵɵreference(8);
    const numberOfResultsContainer_r13 = i0.ɵɵreference(10);
    i0.ɵɵproperty("ngIf", ctx_r1.tableName && (ctx_r1.selectionMode === "checkbox" || ctx_r1.selectionMode === "ez-checkbox"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHeader);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", additionalFiltersBlockBelowSearchTextBox_r12);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", numberOfResultsContainer_r13);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_th_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 37);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_th_3_p_treeTableSortIcon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-treeTableSortIcon", 41);
  }
  if (rf & 2) {
    const col_r14 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("field", col_r14.field);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 38)(1, "span", 39);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ezUncamelcase");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, EzTableTreeComponent_ng_template_3_ng_container_1_th_3_p_treeTableSortIcon_4_Template, 1, 1, "p-treeTableSortIcon", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r14 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ttSortableColumn", col_r14.field);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, ctx_r1.replaceHeaderText(col_r14.field)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.enableSorting);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_th_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 42);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 42);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_th_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "ez-button-icon", 43);
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_3_ng_container_1_th_7_ng_container_1_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r1.onAddItemClick());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconClass", "add-2pt");
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_th_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 42);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_3_ng_container_1_th_7_ng_container_1_Template, 2, 1, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showAdd);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_th_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 42);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, EzTableTreeComponent_ng_template_3_ng_container_1_th_2_Template, 1, 0, "th", 34)(3, EzTableTreeComponent_ng_template_3_ng_container_1_th_3_Template, 5, 5, "th", 35)(4, EzTableTreeComponent_ng_template_3_ng_container_1_th_4_Template, 1, 0, "th", 36)(5, EzTableTreeComponent_ng_template_3_ng_container_1_ng_container_5_Template, 1, 0, "ng-container", 13)(6, EzTableTreeComponent_ng_template_3_ng_container_1_th_6_Template, 1, 0, "th", 36)(7, EzTableTreeComponent_ng_template_3_ng_container_1_th_7_Template, 2, 1, "th", 36)(8, EzTableTreeComponent_ng_template_3_ng_container_1_th_8_Template, 1, 0, "th", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columns_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.reorderableRows && !ctx_r1.colIsSorted);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", columns_r16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHiddenColumnInfo && ctx_r1.unSelectedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customActionsHeadersTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCopy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDelete);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_2_th_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 37);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_2_th_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 45);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r17 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", col_r17.label, " ");
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_2_th_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 42);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_2_th_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 42);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_2_th_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 42);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_2_th_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "th", 42);
  }
}
function EzTableTreeComponent_ng_template_3_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, EzTableTreeComponent_ng_template_3_ng_container_2_th_2_Template, 1, 0, "th", 34)(3, EzTableTreeComponent_ng_template_3_ng_container_2_th_3_Template, 2, 1, "th", 44)(4, EzTableTreeComponent_ng_template_3_ng_container_2_th_4_Template, 1, 0, "th", 36)(5, EzTableTreeComponent_ng_template_3_ng_container_2_ng_container_5_Template, 1, 0, "ng-container", 13)(6, EzTableTreeComponent_ng_template_3_ng_container_2_th_6_Template, 1, 0, "th", 36)(7, EzTableTreeComponent_ng_template_3_ng_container_2_th_7_Template, 1, 0, "th", 36)(8, EzTableTreeComponent_ng_template_3_ng_container_2_th_8_Template, 1, 0, "th", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.reorderableRows && !ctx_r1.colIsSorted);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHiddenColumnInfo && ctx_r1.unSelectedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customActionsHeadersTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCopy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDelete);
  }
}
function EzTableTreeComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableTreeComponent_ng_template_3_ng_container_0_Template, 1, 0, "ng-container", 19)(1, EzTableTreeComponent_ng_template_3_ng_container_1_Template, 9, 7, "ng-container", 10)(2, EzTableTreeComponent_ng_template_3_ng_container_2_Template, 9, 7, "ng-container", 10);
  }
  if (rf & 2) {
    const columns_r16 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customHeadersTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c6, columns_r16));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.customHeadersTemplate && !ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.columnList);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_p_treeTableToggler_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-treeTableToggler", 54);
  }
  if (rf & 2) {
    const rowNode_r18 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵstyleProp("margin-left", 0 + "px");
    i0.ɵɵproperty("rowNode", rowNode_r18);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_p_treeTableCheckbox_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-treeTableCheckbox", 55);
  }
  if (rf & 2) {
    const rowNode_r18 = i0.ɵɵnextContext(4).$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", rowNode_r18)("disabled", ctx_r1.rowEdit);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_ez_checkbox_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-checkbox", 56);
    i0.ɵɵlistener("valueChanged", function EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_ez_checkbox_3_Template_ez_checkbox_valueChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r19);
      const rowNode_r18 = i0.ɵɵnextContext(4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEZCheckboxRowSelect($event, rowNode_r18.node));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("selected", ctx_r1.EZCheckboxRowSelected)("binary", true)("disabled", ctx_r1.rowEdit);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 50);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_p_treeTableToggler_1_Template, 1, 3, "p-treeTableToggler", 51)(2, EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_p_treeTableCheckbox_2_Template, 1, 2, "p-treeTableCheckbox", 52)(3, EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_ez_checkbox_3_Template, 1, 3, "ez-checkbox", 53)(4, EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_ng_container_4_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r20 = ctx.$implicit;
    const i_r21 = ctx.index;
    i0.ɵɵnextContext(2);
    const ezRow_r22 = i0.ɵɵreference(1);
    const ctx_r22 = i0.ɵɵnextContext();
    const rowData_r24 = ctx_r22.rowData;
    const editing_r25 = ctx_r22.editing;
    const ri_r26 = ctx_r22.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", col_r20.field)("ngClass", i0.ɵɵpureFunction1(7, _c22, i_r21 == 0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r21 == 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode === "checkbox" && i_r21 == 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectionMode === "ez-checkbox" && i_r21 == 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.columnsOutput)("ngTemplateOutletContext", i0.ɵɵpureFunction4(27, _c12, rowData_r24, col_r20.field, editing_r25, i0.ɵɵpureFunctionV(9, _c23, [ctx_r1.highlightThisRow(ezRow_r22), ctx_r1.highlightIf(ezRow_r22, "bg-success"), ctx_r1.highlightIf(ezRow_r22, "bg-pink"), ctx_r1.highlightIf(ezRow_r22, "bg-danger"), ctx_r1.highlightIf(ezRow_r22, "bg-warning"), ctx_r1.highlightIf(ezRow_r22, "bg-complete"), ctx_r1.highlightIf(ezRow_r22, "bg-info"), ctx_r1.highlightIf(ezRow_r22, "font-weight-bold"), ctx_r1.highlightIf(ezRow_r22, "font-italic"), ctx_r1.highlightIf(ezRow_r22, "text-secondary"), ctx_r1.highlightIf(ezRow_r22, "parent-row"), ctx_r1.highlightIf(ezRow_r22, "child-row"), ctx_r1.highlightIf(ezRow_r22, "empty-row"), ctx_r1.editRow(rowData_r24), ctx_r1.cancelEditRow(ri_r26), ctx_r1.saveEditRow(rowData_r24, ri_r26), ctx_r1.hideEdit(ezRow_r22)])));
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_td_1_Template, 5, 32, "td", 49);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columns_r27 = i0.ɵɵnextContext(2).columns;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", columns_r27);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_3_td_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_3_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 58);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_4_tr_0_ng_container_3_td_1_ng_container_1_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r28 = ctx.$implicit;
    const ctx_r22 = i0.ɵɵnextContext(3);
    const rowData_r24 = ctx_r22.rowData;
    const editing_r25 = ctx_r22.editing;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngSwitch", col_r28.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.columnsOutput)("ngTemplateOutletContext", i0.ɵɵpureFunction3(3, _c13, rowData_r24, col_r28.value, editing_r25));
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_4_tr_0_ng_container_3_td_1_Template, 2, 7, "td", 57);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.columnList);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_5_span_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 63);
    i0.ɵɵpipe(1, "ezLongToDots");
  }
  if (rf & 2) {
    const col_r29 = ctx.$implicit;
    const rowData_r24 = i0.ɵɵnextContext(4).rowData;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHtml", i0.ɵɵpipeBind2(1, 1, ctx_r1.outputUnselectedColumnData(rowData_r24, col_r29), 300), i0.ɵɵsanitizeHtml);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_5_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 60)(1, "ez-tooltip", 61);
    i0.ɵɵtemplate(2, EzTableTreeComponent_ng_template_4_tr_0_td_5_span_1_div_2_Template, 2, 4, "div", 62);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("hasCustomizedContent", true)("tooltipPosition", "top-left");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.unSelectedColumns);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 42);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_4_tr_0_td_5_span_1_Template, 3, 3, "span", 59);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rowData_r24 = i0.ɵɵnextContext(2).rowData;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.hiddenInfoColumnHasData(rowData_r24));
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 42)(1, "ez-button-icon", 64);
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_4_tr_0_td_7_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r30);
      const rowData_r24 = i0.ɵɵnextContext(2).rowData;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCopyRow(rowData_r24));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    const rowData_r24 = ctx_r22.rowData;
    const ri_r26 = ctx_r22.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("isSecondaryButton", true)("cssClass", "button-icon-medium")("isIconOnly", true)("iconClass", "copy-paste-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r24, ri_r26));
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_8_ez_button_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-button-icon", 68);
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_4_tr_0_td_8_ez_button_icon_1_Template_ez_button_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r31);
      const rowData_r24 = i0.ɵɵnextContext(3).rowData;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEdit(rowData_r24));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    const rowData_r24 = ctx_r22.rowData;
    const ri_r26 = ctx_r22.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isSecondaryButton", true)("isIconOnly", true)("cssClass", "button-icon-medium")("iconClass", "edit-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r24, ri_r26));
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_8_ez_button_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-button-icon", 69);
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_4_tr_0_td_8_ez_button_icon_2_Template_ez_button_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r32);
      const ri_r26 = i0.ɵɵnextContext(3).rowIndex;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEditCancel(ri_r26));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    const rowData_r24 = ctx_r22.rowData;
    const ri_r26 = ctx_r22.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isSecondaryButton", true)("isIconOnly", true)("cssClass", "button-icon-medium")("iconClass", "undo-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r24, ri_r26));
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 65);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_4_tr_0_td_8_ez_button_icon_1_Template, 1, 5, "ez-button-icon", 66)(2, EzTableTreeComponent_ng_template_4_tr_0_td_8_ez_button_icon_2_Template, 1, 5, "ez-button-icon", 67);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const editing_r25 = i0.ɵɵnextContext(2).editing;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !editing_r25);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", editing_r25);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_9_ez_button_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ez-button-icon", 71);
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_4_tr_0_td_9_ez_button_icon_1_Template_ez_button_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r33);
      const ctx_r22 = i0.ɵɵnextContext(3);
      const rowData_r24 = ctx_r22.rowData;
      const ri_r26 = ctx_r22.rowIndex;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEditSave(rowData_r24, ri_r26));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(3);
    const rowData_r24 = ctx_r22.rowData;
    const ri_r26 = ctx_r22.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isSecondaryButton", true)("isIconOnly", true)("cssClass", "button-icon-medium")("iconClass", "check-2pt");
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r24, ri_r26));
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 42);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_4_tr_0_td_9_ez_button_icon_1_Template, 1, 5, "ez-button-icon", 70);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const editing_r25 = i0.ɵɵnextContext(2).editing;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", editing_r25);
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_td_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 42)(1, "ez-button-icon", 72);
    i0.ɵɵlistener("click", function EzTableTreeComponent_ng_template_4_tr_0_td_10_Template_ez_button_icon_click_1_listener() {
      i0.ɵɵrestoreView(_r34);
      const rowData_r24 = i0.ɵɵnextContext(2).rowData;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDelete(rowData_r24));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    const rowData_r24 = ctx_r22.rowData;
    const ri_r26 = ctx_r22.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cssClass", "button-icon-medium")("isIconOnly", true)("isSecondaryButton", true)("iconClass", "delete-2pt")("disabled", ctx_r1.showDisabledDeleteIcon);
    i0.ɵɵattribute("data-cy", ctx_r1.cypressRowId("button", rowData_r24, ri_r26));
  }
}
function EzTableTreeComponent_ng_template_4_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 47, 5);
    i0.ɵɵtemplate(2, EzTableTreeComponent_ng_template_4_tr_0_ng_container_2_Template, 2, 1, "ng-container", 10)(3, EzTableTreeComponent_ng_template_4_tr_0_ng_container_3_Template, 2, 1, "ng-container", 10)(4, EzTableTreeComponent_ng_template_4_tr_0_ng_container_4_Template, 1, 0, "ng-container", 19)(5, EzTableTreeComponent_ng_template_4_tr_0_td_5_Template, 2, 1, "td", 36)(6, EzTableTreeComponent_ng_template_4_tr_0_ng_container_6_Template, 1, 0, "ng-container", 19)(7, EzTableTreeComponent_ng_template_4_tr_0_td_7_Template, 2, 5, "td", 36)(8, EzTableTreeComponent_ng_template_4_tr_0_td_8_Template, 3, 2, "td", 48)(9, EzTableTreeComponent_ng_template_4_tr_0_td_9_Template, 2, 1, "td", 36)(10, EzTableTreeComponent_ng_template_4_tr_0_td_10_Template, 2, 6, "td", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ezRow_r22 = i0.ɵɵreference(1);
    const ctx_r22 = i0.ɵɵnextContext();
    const rowNode_r18 = ctx_r22.$implicit;
    const rowData_r24 = ctx_r22.rowData;
    const editing_r25 = ctx_r22.editing;
    const ri_r26 = ctx_r22.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ttRow", rowNode_r18);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.customColumnsTemplate && !ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customColumnsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(26, _c10, rowData_r24, editing_r25, i0.ɵɵpureFunctionV(12, _c21, [ctx_r1.highlightThisRow(ezRow_r22), ctx_r1.highlightIf(ezRow_r22, "bg-success"), ctx_r1.highlightIf(ezRow_r22, "bg-pink"), ctx_r1.highlightIf(ezRow_r22, "bg-danger"), ctx_r1.highlightIf(ezRow_r22, "bg-warning"), ctx_r1.highlightIf(ezRow_r22, "bg-complete"), ctx_r1.highlightIf(ezRow_r22, "bg-info"), ctx_r1.highlightIf(ezRow_r22, "font-weight-bold"), ctx_r1.highlightIf(ezRow_r22, "font-italic"), ctx_r1.highlightIf(ezRow_r22, "text-secondary"), ctx_r1.editRow(rowData_r24), ctx_r1.cancelEditRow(ri_r26), ctx_r1.saveEditRow(rowData_r24, ri_r26)])));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHiddenColumnInfo && ctx_r1.unSelectedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customActionsTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(44, _c10, rowData_r24, editing_r25, i0.ɵɵpureFunctionV(30, _c21, [ctx_r1.highlightThisRow(ezRow_r22), ctx_r1.highlightIf(ezRow_r22, "bg-success"), ctx_r1.highlightIf(ezRow_r22, "bg-pink"), ctx_r1.highlightIf(ezRow_r22, "bg-danger"), ctx_r1.highlightIf(ezRow_r22, "bg-warning"), ctx_r1.highlightIf(ezRow_r22, "bg-complete"), ctx_r1.highlightIf(ezRow_r22, "bg-info"), ctx_r1.highlightIf(ezRow_r22, "font-weight-bold"), ctx_r1.highlightIf(ezRow_r22, "font-italic"), ctx_r1.highlightIf(ezRow_r22, "text-secondary"), ctx_r1.editRow(rowData_r24), ctx_r1.cancelEditRow(ri_r26), ctx_r1.saveEditRow(rowData_r24, ri_r26)])));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCopy && !editing_r25);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", editing_r25 && ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDelete && !editing_r25);
  }
}
function EzTableTreeComponent_ng_template_4_tr_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_4_tr_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr")(1, "td", 73);
    i0.ɵɵtemplate(2, EzTableTreeComponent_ng_template_4_tr_1_ng_container_2_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    const rowData_r24 = ctx_r22.rowData;
    const columns_r27 = ctx_r22.columns;
    const ri_r26 = ctx_r22.rowIndex;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("colSpan", columns_r27.length + 3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.editTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(3, _c14, rowData_r24, ctx_r1, ri_r26));
  }
}
function EzTableTreeComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableTreeComponent_ng_template_4_tr_0_Template, 11, 48, "tr", 46)(1, EzTableTreeComponent_ng_template_4_tr_1_Template, 3, 7, "tr", 10);
  }
  if (rf & 2) {
    const editing_r25 = ctx.editing;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", (editing_r25 && !ctx_r1.hasEditTemplate || !editing_r25) && !ctx_r1.customColumnsTemplateNoRow);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", editing_r25 && ctx_r1.hasEditTemplate && !ctx_r1.customColumnsTemplateNoRow);
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_2_td_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Totals ");
    i0.ɵɵelementContainerEnd();
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_2_td_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getColumnTotal(col_r35.label));
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_2_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_2_td_1_ng_container_1_Template, 2, 0, "ng-container", 10)(2, EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_2_td_1_span_2_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r35 = ctx.$implicit;
    const i_r36 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r36 === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isTotalColumn(col_r35.label));
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_2_td_1_Template, 3, 2, "td", 75);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.columnList);
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_3_td_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Totals ");
    i0.ɵɵelementContainerEnd();
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_3_td_1_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r37 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.getColumnTotal(col_r37.field));
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_3_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtemplate(1, EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_3_td_1_ng_container_1_Template, 2, 0, "ng-container", 10)(2, EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_3_td_1_span_2_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r37 = ctx.$implicit;
    const i_r38 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r38 === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isTotalColumn(col_r37.field));
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_3_td_1_Template, 3, 2, "td", 75);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columns_r39 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", columns_r39);
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_td_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 42);
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_td_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 42);
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_td_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 42);
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_td_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 42);
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_2_Template, 2, 1, "ng-container", 10)(3, EzTableTreeComponent_5_ng_template_0_ng_container_0_ng_container_3_Template, 2, 1, "ng-container", 10)(4, EzTableTreeComponent_5_ng_template_0_ng_container_0_td_4_Template, 1, 0, "td", 36)(5, EzTableTreeComponent_5_ng_template_0_ng_container_0_td_5_Template, 1, 0, "td", 36)(6, EzTableTreeComponent_5_ng_template_0_ng_container_0_td_6_Template, 1, 0, "td", 36)(7, EzTableTreeComponent_5_ng_template_0_ng_container_0_td_7_Template, 1, 0, "td", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.columnList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showHiddenColumnInfo && ctx_r1.unSelectedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showCopy);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showEdit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showDelete);
  }
}
function EzTableTreeComponent_5_ng_template_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_5_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableTreeComponent_5_ng_template_0_ng_container_0_Template, 8, 6, "ng-container", 10)(1, EzTableTreeComponent_5_ng_template_0_ng_container_1_Template, 1, 0, "ng-container", 19);
  }
  if (rf & 2) {
    const columns_r39 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.customHeadersTemplate && ctx_r1.showFooterTotals);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c6, columns_r39));
  }
}
function EzTableTreeComponent_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableTreeComponent_5_ng_template_0_Template, 2, 5, "ng-template", 74);
  }
}
function EzTableTreeComponent_ng_template_6_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_6_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_6_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_6_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const columns_r40 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customEmptyMessageTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, columns_r40));
  }
}
function EzTableTreeComponent_ng_template_6_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const columns_r40 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵattribute("colspan", columns_r40 && columns_r40.length ? columns_r40.length : 1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.emptymessage, " ");
  }
}
function EzTableTreeComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EzTableTreeComponent_ng_template_6_ng_container_0_Template, 1, 0, "ng-container", 19);
    i0.ɵɵelementStart(1, "tr");
    i0.ɵɵtemplate(2, EzTableTreeComponent_ng_template_6_ng_container_2_Template, 2, 4, "ng-container", 10)(3, EzTableTreeComponent_ng_template_6_td_3_Template, 2, 2, "td", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const columns_r40 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.customEmptyMessageTemplateNoRow)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c6, columns_r40));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.customEmptyMessageTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.customEmptyMessageTemplate && !ctx_r1.customEmptyMessageTemplateNoRow);
  }
}
function EzTableTreeComponent_ng_template_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EzTableTreeComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 76);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_7_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementContainerStart(2);
    i0.ɵɵelement(3, "p-divider", 77);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox)("ngClass", i0.ɵɵpureFunction1(3, _c24, ctx_r1.showAdditionalFiltersBlockBelowSearchTextBox));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.additionalFiltersBlockBelowSearchTextBoxTemplate);
  }
}
function EzTableTreeComponent_ng_template_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "h2", 79);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "ezLocale");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_5_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, "FoundNumberOfResults", (tmp_5_0 = ctx_r1.numberOfFilteredRows) !== null && tmp_5_0 !== undefined ? tmp_5_0 : ctx_r1._rows.length), " ");
  }
}
function EzTableTreeComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78);
    i0.ɵɵtemplate(1, EzTableTreeComponent_ng_template_9_ng_container_1_Template, 4, 4, "ng-container", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c16, ctx_r1.showPrimaryGridHeaderButton, !ctx_r1.showPrimaryGridHeaderButton));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.selectedRows || !(ctx_r1.selectedRows == null ? null : ctx_r1.selectedRows.length));
  }
}
class EzTable {
  sortPosition(a, b) {
    const aPosition = a.position;
    const bPosition = b.position;
    let comparison = 0;
    if (aPosition > bPosition) {
      comparison = 1;
    } else if (aPosition < bPosition) {
      comparison = -1;
    }
    return comparison;
  }
}
function toCypressName(value) {
  return value.replace(/[^a-z0-9\s]/gi, '').replace(/\s/g, '-').toLowerCase();
}
let ColumnsCountClassDirective = /*#__PURE__*/(() => {
  class ColumnsCountClassDirective {
    constructor(el, renderer) {
      this.el = el;
      this.renderer = renderer;
    }
    ngOnChanges() {
      const className = this.getClassName(this.selectedColumns.length);
      if (this.previousClassName) {
        this.renderer.removeClass(this.el.nativeElement, this.previousClassName);
      }
      this.renderer.addClass(this.el.nativeElement, className);
      this.previousClassName = className;
    }
    getClassName(columnCount) {
      // replace this with your actual logic for generating the class name
      return `selected-columns-length-${columnCount}`;
    }
    static {
      this.ɵfac = function ColumnsCountClassDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ColumnsCountClassDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ColumnsCountClassDirective,
        selectors: [["", "columnsCountClass", ""]],
        inputs: {
          selectedColumns: [0, "columnsCountClass", "selectedColumns"]
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return ColumnsCountClassDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FrozenColumnsDirective = /*#__PURE__*/(() => {
  class FrozenColumnsDirective {
    constructor(el, renderer) {
      this.el = el;
      this.renderer = renderer;
    }
    ngAfterViewInit() {
      this.waitForData();
      this.resizeListener = this.renderer.listen('window', 'resize', () => {
        this.setFrozenColumns();
      });
    }
    waitForData() {
      // Listen for the data available event
      // Assuming 'dataAvailable' is a custom event emitted by the table component
      this.dataAvailable.subscribe(() => {
        setTimeout(() => {
          this.setFrozenColumns();
        }, 100);
      });
    }
    ngOnDestroy() {
      if (this.resizeListener) {
        this.resizeListener();
      }
      if (this.dataAvailable) {
        this.dataAvailable.unsubscribe();
      }
    }
    setFrozenColumns() {
      // Clear existing left and right styles to recalculate correctly
      const tdsLeft = this.el.nativeElement.querySelectorAll('td[alignfrozen="left"]');
      const thsLeft = this.el.nativeElement.querySelectorAll('th[alignfrozen="left"]');
      const tdsRight = this.el.nativeElement.querySelectorAll('td[alignfrozen="right"]');
      const thsRight = this.el.nativeElement.querySelectorAll('th[alignfrozen="right"]');
      [...tdsLeft, ...tdsRight].forEach(td => {
        this.renderer.setStyle(td, 'left', null);
        this.renderer.setStyle(td, 'right', null);
      });
      [...thsLeft, ...thsRight].forEach(th => {
        this.renderer.setStyle(th, 'left', null);
        this.renderer.setStyle(th, 'right', null);
      });
      // Process left-aligned elements
      setTimeout(() => {
        this.processLeftAlignedElements(thsLeft);
      }, 1500);
      // Process right-aligned elements
      this.processRightAlignedElements(thsRight);
    }
    processLeftAlignedElements(headerCells) {
      // Get all rows in the table
      const rows = this.el.nativeElement.querySelectorAll('tr');
      if (rows.length === 0) return;
      // Iterate over the rows to get the body cells
      const bodyCellsArray = Array.from(rows).slice(1).map(row => row.querySelectorAll('td.p-frozen-column[alignfrozen="left"]'));
      if (bodyCellsArray.length === 0 || !bodyCellsArray[0].length) return;
      // Initialize the left offset
      let leftOffset = -2;
      // Iterate through the header cells and corresponding body cells
      headerCells.forEach((th, index) => {
        this.renderer.setStyle(th, 'left', `${leftOffset}px`);
        const thWidth = th.offsetWidth;
        leftOffset += thWidth;
        bodyCellsArray.forEach(bodyCells => {
          const td = bodyCells[index];
          if (td) {
            this.renderer.setStyle(td, 'left', `${leftOffset - thWidth}px`);
          }
        });
      });
    }
    processRightAlignedElements(headerCells) {
      if (headerCells.length > 0) {
        this.renderer.addClass(headerCells[0], 'first-right-aligned');
      }
      // Get all rows in the table
      const rows = this.el.nativeElement.querySelectorAll('tr');
      if (rows.length === 0) return;
      // Iterate over the rows to get the body cells
      const bodyCellsArray = Array.from(rows).slice(1).map(row => row.querySelectorAll('td.p-frozen-column[alignfrozen="right"]'));
      if (bodyCellsArray.length === 0 || !bodyCellsArray[0].length) return;
      // Initialize the right offset
      let rightOffset = 0;
      // Iterate through the header cells and corresponding body cells in reverse order
      Array.from(headerCells).reverse().forEach((th, reverseIndex) => {
        const index = headerCells.length - 1 - reverseIndex;
        this.renderer.setStyle(th, 'right', `${rightOffset}px`);
        const thWidth = th.offsetWidth;
        rightOffset += thWidth;
        bodyCellsArray.forEach(bodyCells => {
          this.renderer.addClass(bodyCells[0], 'first-right-aligned');
          const td = bodyCells[index];
          if (td) {
            this.renderer.setStyle(td, 'right', `${rightOffset - thWidth}px`);
          }
        });
      });
    }
    static {
      this.ɵfac = function FrozenColumnsDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FrozenColumnsDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: FrozenColumnsDirective,
        selectors: [["", "frozenColumns", ""]],
        inputs: {
          dataAvailable: "dataAvailable"
        },
        standalone: false
      });
    }
  }
  return FrozenColumnsDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EzTableComponent = /*#__PURE__*/(() => {
  let EzTableComponent = class EzTableComponent extends EzTable {
    set originalEditRowDataForError(originalRow) {
      //if there was a validation error for the row when saving...
      if (originalRow !== null) {
        //get the original values from before the edit (table is responsible for passing that in)
        this.originalEditRowWithError = originalRow;
        //get the new/edited values
        const row = this._rows.find(x => x[this.keyField] == originalRow[this.keyField]);
        this.dt.initRowEdit(row);
        this.onEdit(row);
      }
      //else, the error row is being cleared
      else {
        //if we have the original edit row from a previous validation error, cancel the edit
        if (this.originalEditRowWithError) {
          this.clonedRow = this.originalEditRowWithError;
          this.dt.cancelRowEdit(this.originalEditRowWithError[this.keyField]);
          this.originalEditRowWithError = null;
        }
      }
    }
    // @ts-ignore
    set customSortColsAndFunction({
      colsArray,
      callBackFunction
    }) {
      if (colsArray && colsArray.length > 0 && callBackFunction) {
        this.hasCustomSort = true;
        this._customSortColumns = colsArray;
        this._customSortFunction = callBackFunction;
      } else {
        throw new Error('DEVELOPER!, Please provide a array of column names and the call back function to use for sorting.');
      }
    }
    set tableActions(actions) {
      this._tableActions = actions;
    }
    set filterColumns(filterColumns) {
      if (filterColumns) {
        this._customFilterColumns = filterColumns;
      }
    }
    set headerReplacements(value) {
      this._headerReplacements = value;
      this.headerReplacementsStream.next(value);
    }
    set rows(value) {
      this._rows = value;
      this.rowsStream.next(value);
    }
    set firstPageNumberToShow(value) {
      this._firstPageNumberToShow = value;
    }
    set reorderableRows(value) {
      if (value) {
        this._reorderableRows = value;
      }
    }
    constructor(ezLayoutService, cdr) {
      super();
      this.ezLayoutService = ezLayoutService;
      this.cdr = cdr;
      this.showHeader = false;
      this.showAdd = false;
      this.showEdit = false;
      this.showDelete = false;
      this.showDisabledDeleteIcon = false;
      this.showDisabledEditIcon = false;
      this.showCopy = false;
      this.showFooter = true;
      this.showFooterTotals = false;
      this.showExportToCsv = false;
      this.showAllRowPerPage = false;
      this.showRefreshIcon = false;
      this.showDeleteAction = false;
      this.disableInLineRowEdit = false;
      this.showHiddenColumnInfo = true;
      this.showHiddenColumnSelector = true;
      this.filtersApplied = false;
      this.showClearFilters = false;
      this.showAdditionalFiltersBlockBelowSearchTextBox = false;
      this.showAdditionalFiltersBlockToggleIcon = false;
      this.showGlobalSearchField = false;
      this.hasEditTemplate = false;
      this.priorityColumnTitle = '';
      this.selectionMode = null;
      this.selectedDefaultTableAction = null;
      this.hideColumnList = [];
      this.doNotShowTheseColumnsOnLoad = [];
      this.alwaysShownColumns = [];
      this.footerTotalColumnList = [];
      this.emptymessage = ResourcesProvider.rks.NoRecordsFound;
      this.globalFilterPlaceholderText = ResourcesProvider.rks.SearchItems;
      this.globalSearchTextMaxLengthLimit = 0;
      this.defaultSortOrderField = null;
      this.rowsCount = 20;
      this.defaultSortOrderFieldType = 1;
      this.rowPerPageOptions = [10, 20, 50, 100];
      this.enableSorting = true;
      this.enablePagination = true;
      this.getFooterTotalFunction = null;
      this.enableLazyLoading = false;
      this.totalRecords = 0;
      this.loading = false;
      this.doFrontEndGlobalSearch = true;
      this.orderArrowsAvailable = false;
      this.showNumberOfRows = true;
      this.enableActionApplyUponSelection = true;
      this.selectAllItemsPerSinglePageOnly = true;
      this.isMobileDevice = false;
      this.isTabletDevice = false;
      this.showSecondaryGridHeaderButton = false;
      this.showAdditionalSecondaryGridHeaderButton = false;
      this.showPrimaryGridHeaderButton = false;
      this.secondaryGridHeaderButtonLabel = 'Cancel';
      this.additionalSecondaryGridHeaderButtonLabel = 'Cancel';
      this.primaryGridHeaderButtonLabel = 'Save';
      this.secondaryGridHeaderButtonCyName = 'secondary-grid-header-button';
      this.additionalSecondaryGridHeaderButtonCyName = 'additional-secondary-grid-header-button';
      this.primaryGridHeaderButtonCyName = 'primary-grid-header-button';
      this.secondaryGridHeaderButtonDisabled = false;
      this.additionalSecondaryGridHeaderButtonDisabled = false;
      this.primaryGridHeaderButtonDisabled = false;
      this.showTableName = true;
      this.showCustomMobileTableFooterActionsTemplate = false;
      this.showMobileGridFooterByDefault = false;
      this._customSortColumns = [];
      this.tableActionsDisabled = false;
      this._customFilterColumns = [];
      // - Event Outputs - //
      this.rowClicked = new EventEmitter();
      this.addClicked = new EventEmitter();
      this.editClicked = new EventEmitter();
      this.copyRowClicked = new EventEmitter();
      this.editCancelClicked = new EventEmitter();
      this.editSaveClicked = new EventEmitter();
      this.deleteClicked = new EventEmitter();
      this.actionApply = new EventEmitter();
      this.selectedRowsChange = new EventEmitter();
      this.rowReorderChange = new EventEmitter();
      this.colReorderChange = new EventEmitter();
      this.colSortedChange = new EventEmitter();
      this.lazyLoad = new EventEmitter();
      this.onPageClicked = new EventEmitter();
      this.onGlobalSearchTextChanged = new EventEmitter();
      this.onColumnsChange = new EventEmitter();
      this.dataAvailable = new EventEmitter();
      this.secondaryGridHeaderButtonClicked = new EventEmitter();
      this.additionalSecondaryGridHeaderButtonClicked = new EventEmitter();
      this.primaryGridHeaderbuttonClicked = new EventEmitter();
      this.filtersCleared = new EventEmitter();
      this._headerReplacements = [];
      this._tableActions = [];
      this._filterColumns = [];
      this._firstPageNumberToShow = 0;
      this._reorderableRows = false;
      this.cols = [];
      this.selectedColumns = [];
      this.unSelectedColumns = [];
      this.selectedAction = null;
      this.rowEdit = false;
      this.hasFooter = false;
      this.uncamelcasePipe = new EzUncamelcasePipe();
      this.sortField = null;
      this.sortOrder = 1;
      this.colIsSorted = false;
      this.hasCustomSort = true;
      this.hiddenColumnListStream = new BehaviorSubject([]);
      this.headerReplacementsStream = new BehaviorSubject([]);
      this.rowsStream = new BehaviorSubject([]);
      this.numberOfFilteredRows = null;
      this.tableNamePrefix = 'table';
      this.searchText = '';
      this.optionsSelectionIsActive = false;
      this.showMobileSearchContainer = false;
      // - passable functions for Edit - //
      this.cancelEdit = rowIndex => {
        this.onEditCancel(rowIndex);
      };
      this.saveEdit = (dataRow, ri) => {
        this.onEditSave(dataRow, ri);
      };
    }
    ngOnInit() {
      if (this.customFooterTemplate) {
        this.hasFooter = true;
      }
      if (this.showDeleteAction) {
        this._tableActions.push({
          label: 'Delete',
          value: 'delete'
        });
      }
      this.tableNamePrefix += this.tableName ? '-' + toCypressName(this.tableName) : '';
      this.initColumnsConfiguration();
      this.configureMobileGridFooter();
    }
    ngAfterViewInit() {
      this.setFilters();
      this.setDefaultSortOrder();
    }
    ngOnChanges(changes) {
      if (changes.hideColumnList && changes.hideColumnList.currentValue) {
        this.hiddenColumnListStream.next(changes.hideColumnList.currentValue);
      }
      if (changes.rows && changes.rows.currentValue && changes.rows.previousValue && changes.rows.previousValue.length !== changes.rows.currentValue.length) {
        this.onClearSelection();
      }
      this.dataAvailable.emit();
    }
    initColumnsConfiguration() {
      combineLatest([this.rowsStream.pipe(filter(rows => Array.isArray(rows))), this.hiddenColumnListStream, this.headerReplacementsStream]).pipe(untilDestroyed(this)).subscribe(([rows, hiddenColumnList, headerReplacements]) => {
        this.cols = [];
        this.selectedColumns = [];
        this.unSelectedColumns = [];
        this.numberOfFilteredRows = 0;
        if (Array.isArray(rows) && rows.length > 0) {
          this.numberOfFilteredRows = Array.isArray(rows) ? rows.length : 0;
          const row = rows[0];
          let position = 0;
          for (const field in row) {
            if (field !== this.keyField && hiddenColumnList.indexOf(field) < 0) {
              const col = {
                field: field,
                header: this.replaceHeaderText(field),
                position: position,
                isDisabled: this.alwaysShownColumns.includes(field)
              };
              this.cols.push(col);
              position++;
            }
          }
          if (Array.isArray(this.doNotShowTheseColumnsOnLoad) && this.doNotShowTheseColumnsOnLoad.length) {
            this.selectedColumns = this.cols.filter(col => !this.doNotShowTheseColumnsOnLoad.includes(col.field));
            this.unSelectedColumns = this.cols.filter(col => this.doNotShowTheseColumnsOnLoad.includes(col.field));
          } else {
            this.selectedColumns = [...this.cols];
          }
          this.setFilters();
          this.updateRowsPerPageOptions();
          this.setDefaultSortOrder();
          this.setDefaultSelectedMultipleTableAction();
          this.dataAvailable.emit();
          setTimeout(() => {
            this.cdr.markForCheck();
          }, 1);
        }
      });
    }
    updateRowsPerPageOptions() {
      if (this.showAllRowPerPage) {
        this.rowPerPageOptions = this._rows.length > 100 ? [...this.rowPerPageOptions, this._rows.length] : this.rowPerPageOptions;
      }
    }
    setFilters() {
      if (this.showGlobalSearchField && this._customFilterColumns.length === 0 && this.selectedColumns) {
        // set collection to columns that are visible and available to be visible
        // const searchableColumns = this.unSelectedColumns.concat(this.selectedColumns);
        // const x = Object.keys(searchableColumns).map(f => searchableColumns[f].field);
        // this._filterColumns = x;
        this._filterColumns = Object.keys(this.selectedColumns).map(f => this.selectedColumns[f].field);
      }
    }
    globalFilter(eventTarget, table) {
      this.searchText = eventTarget.value;
      if (this.doFrontEndGlobalSearch && this.checkGlobalSearchTextLimit(this.searchText)) {
        table.filterGlobal(eventTarget.value, 'contains');
      }
      this.onGlobalSearchTextChanged.emit(this.searchText);
      if (this.reorderableRows) {
        this._reorderableRows = !this.searchText;
      }
    }
    clearGlobalSearch() {
      this.txtGlobalFilter.nativeElement.value = '';
      this.globalFilter(this.txtGlobalFilter.nativeElement, this.dt);
    }
    checkGlobalSearchTextLimit(searchText) {
      const searchTextLength = searchText.length;
      if (this.globalSearchTextMaxLengthLimit && searchTextLength > this.globalSearchTextMaxLengthLimit) {
        alert('Search text length limit');
        return false;
      }
      return true;
    }
    onSelectedRow(row) {
      if (this.selectionMode === 'multiple') {
        // rowClicked is the most recently selected row, so pop the last one from the array
        this.rowClicked.emit(this.selectedRows[this.selectedRows.length - 1]);
        this.selectedRowsChange.emit(this.selectedRows);
      } else {
        if (this.selectionMode === 'radio') {
          if (row.data) {
            this.rowClicked.emit(row.data);
          }
        } else {
          this.rowClicked.emit(row);
        }
      }
    }
    onSelectAllRows(rows) {
      this.selectedRows = rows;
      this.selectedRowsChange.emit(this.selectedRows);
    }
    onHeaderCheckboxToggle() {
      this.selectedRowsChange.emit(this.selectedRows);
    }
    onClearSelection() {
      this.selectedRows = [];
    }
    onClearFilters() {
      this.dt.reset();
      this.filtersCleared.emit();
    }
    onLazyLoad(lazyLoadEvent) {
      this.lazyLoad.emit(lazyLoadEvent);
      this.dataAvailable.emit();
    }
    onActionSelected(action) {
      if ((action.value || action.value === 0) && this.enableActionApplyUponSelection) {
        this.onActionApply();
      }
    }
    onActionApply() {
      if (this.selectedAction !== null) {
        const request = {
          action: this.selectedAction,
          rows: this.selectedRows
        };
        this.actionApply.emit(request);
        // It is necessary to clear selected action otherwise
        // user will have to manually clear and select it again in order for action to work
        this.drpTableOptions.clear();
      }
    }
    onAddItemClick() {
      this.addClicked.emit();
    }
    onDelete(row) {
      this.deleteClicked.emit(row);
    }
    onCopyRow(row) {
      // may need a deep copy
      this.clonedRow = {
        ...row
      };
      this.copyRowClicked.emit(row);
    }
    onEdit(row) {
      // check if we need to show in line editing icons
      if (!this.disableInLineRowEdit) {
        // may need a deep copy
        this.rowEdit = true;
        this.clonedRow = {
          ...row
        };
      }
      this.editClicked.emit(row);
    }
    onEditCancel(rowIndex) {
      this.rowEdit = false;
      if (this.originalEditRowWithError) {
        //set the original data back into the clone row.
        //we need this because the clonedRow data was changing as the values changed while in edit mode
        this.clonedRow = this.originalEditRowWithError;
        this.originalEditRowWithError = null;
      }
      this._rows[rowIndex] = this.clonedRow;
      this.clonedRow = null;
      this.editCancelClicked.emit();
      this.dt.cancelRowEdit(this._rows[rowIndex]);
    }
    onEditSave(row, ri) {
      this.clonedRow = null;
      this.rowEdit = false;
      this.editSaveClicked.emit(row);
      this._rows[ri] = row;
      this.dt.cancelRowEdit(this._rows[ri]);
    }
    isTotalColumn(colName) {
      if (this.getFooterTotalFunction) {
        const column = this.footerTotalColumnList.find(tc => tc === colName);
        if (column) {
          this.getColumnTotal(column);
          return true;
        }
      }
      return false;
    }
    getColumnTotal(column) {
      return this.getFooterTotalFunction(this._rows, column);
    }
    highlightThisRow(tr) {
      return color => {
        if (!tr.classList.contains(color)) {
          tr.classList.add(color);
        }
      };
    }
    highlightIf(tr, cssClass) {
      return exp => {
        if (exp) {
          if (!tr.classList.contains(cssClass)) {
            tr.classList.add(cssClass);
          }
        } else {
          tr.classList.remove(cssClass);
        }
      };
    }
    editRow(rowData) {
      return () => {
        this.dt.initRowEdit(rowData);
        this.onEdit(rowData);
      };
    }
    cancelEditRow(rowIndex) {
      return () => {
        this.onEditCancel(rowIndex);
      };
    }
    saveEditRow(rowData, rowIndex) {
      return () => {
        this.onEditSave(rowData, rowIndex);
      };
    }
    onRowReorder(rowReorderEvent) {
      // by the time this event is raised, the _rows collection is already updated
      // with the moved row. Therefore, using the drop index to get both elements is correct
      const dragData = this._rows[rowReorderEvent.dropIndex];
      let dropData;
      // if the row was dragged to be the first row, then there will be no drop row above it
      if (rowReorderEvent.dropIndex > 0) {
        // the drop data is always the row above the line in between the 2 rows where the drop occurred
        dropData = this._rows[rowReorderEvent.dropIndex - 1];
      }
      const ezTableRowReorderModel = {
        dragData,
        dropData,
        dragIndex: rowReorderEvent.dragIndex,
        dropIndex: rowReorderEvent.dropIndex
      };
      this.rowReorderChange.emit(ezTableRowReorderModel);
    }
    onRowReorderByClick(ri, isDecrement) {
      const dropIndex = isDecrement ? ri + 1 : ri - 1;
      const dragData = this._rows[ri];
      const dropData = this._rows[dropIndex];
      const ezTableRowReorderModel = {
        dragData,
        dropData,
        dragIndex: ri,
        dropIndex: dropIndex
      };
      this.rowReorderChange.emit(ezTableRowReorderModel);
    }
    onColReorder(colReorderEvent) {
      this.colReorderChange.emit(colReorderEvent);
    }
    onSort(colSortedEvent) {
      this.sortField = colSortedEvent.field;
      this.sortOrder = colSortedEvent.order;
      // if the grid is now sorted by the default sort field and sort order,
      // then the grid is not "sorted" in that its the default sort and drag and drop should be allowed
      if (this.sortField === this.defaultSortOrderField && this.sortOrder === 1) {
        this.colIsSorted = false;
      } else {
        this.colIsSorted = true;
      }
      this.colSortedChange.emit(colSortedEvent);
      this.dataAvailable.emit();
    }
    onFilter(filterEvent) {
      if (filterEvent && Array.isArray(filterEvent.filteredValue)) {
        this.numberOfFilteredRows = filterEvent.filteredValue.length;
      }
    }
    customSort(event) {
      event.data?.sort((data1, data2) => {
        if (this.hasCustomSort && this._customSortColumns.indexOf(event.field) >= 0) {
          // event order is whether its asc (1) or desc(-1)
          const customOrder = this._customSortFunction(event.field, data1, data2);
          return event.order * customOrder;
        } else {
          const value1 = data1[event.field];
          const value2 = data2[event.field];
          let result;
          if (value1 == null && value2 != null) {
            result = -1;
          } else if (value1 != null && value2 == null) {
            result = 1;
          } else if (value1 == null && value2 == null) {
            result = 0;
          } else if (typeof value1 === 'string' && typeof value2 === 'string') {
            result = value1.localeCompare(value2);
          } else {
            result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
          }
          return event.order * result;
        }
      });
      this.dataAvailable.emit();
    }
    setDefaultSortOrder() {
      if (this.dt && !this.enableLazyLoading) {
        this.dt.clear();
        this.sortOrder = this.defaultSortOrderFieldType;
        this.dt.sortOrder = this.defaultSortOrderFieldType;
        this.colIsSorted = false;
        if (this.defaultSortOrderField) {
          this.sortField = this.defaultSortOrderField;
          this.dt.sortField = this.defaultSortOrderField;
        } else {
          this.sortField = null;
          this.dt.sortField = null;
        }
      }
    }
    setDefaultSelectedMultipleTableAction() {
      this.selectedAction = this.selectedDefaultTableAction !== null ? this.selectedDefaultTableAction : null;
    }
    onRefreshTableClick() {
      if (this.sortOrder !== 1 || !this.defaultSortOrderField && this.sortField || this.defaultSortOrderField && this.sortField !== this.defaultSortOrderField) {
        this.setDefaultSortOrder();
      }
    }
    onSelectedColumnsChange(selectedCols) {
      this.unSelectedColumns = this.cols.filter(col => !selectedCols.map(selectedCol => selectedCol.field).includes(col.field));
      this.selectedColumns.sort(this.sortPosition);
      this.setFilters();
      this.globalFilter(this.txtGlobalFilter.nativeElement, this.dt);
      this.onColumnsChange.emit(selectedCols);
    }
    onAdditionalFiltersBlockToggleIconClick() {
      this.showAdditionalFiltersBlockBelowSearchTextBox = !this.showAdditionalFiltersBlockBelowSearchTextBox;
      this.showMobileSearchContainer = false;
    }
    outputUnselectedColumnData(rowData, col) {
      let output = '';
      if (rowData[col.field]) {
        output = '<strong>' + col.header + ':</strong> ' + rowData[col.field];
      }
      return output;
    }
    hiddenInfoColumnHasData(rowData) {
      let hasInfo = false;
      for (const col of this.unSelectedColumns) {
        if (rowData[col.field]) {
          hasInfo = true;
          break;
        }
      }
      return hasInfo;
    }
    replaceHeaderText(prop) {
      let headerText = this.uncamelcasePipe.transform(prop);
      if (this._headerReplacements.length) {
        const header = this._headerReplacements.find(value => value.value === prop);
        headerText = header ? header.label : headerText;
      }
      return headerText;
    }
    cypressRowId(controlTypeDescription, rowData, rowIndex) {
      const rowId = controlTypeDescription + (this.keyField ? '-' + this.keyField.toLowerCase() + '-' + rowData[this.keyField] : '-row-id-' + rowIndex);
      return this.tableNamePrefix + '-' + rowId;
    }
    onPage(event) {
      this.dataAvailable.emit();
      this.onPageClicked.emit(event);
    }
    toggleOptionsSelectionStatus() {
      this.optionsSelectionIsActive = !this.optionsSelectionIsActive;
    }
    onSearchIconClick() {
      this.showMobileSearchContainer = !this.showMobileSearchContainer;
      this.showAdditionalFiltersBlockBelowSearchTextBox = false;
    }
    onSwitchToMainFooterClick() {
      this.ezLayoutService.changeFooterStatus(true);
      this.showAdditionalFiltersBlockBelowSearchTextBox = false;
      this.showMobileSearchContainer = false;
    }
    configureMobileGridFooter() {
      if (this.showMobileGridFooterByDefault && this.isMobileDevice) {
        this.ezLayoutService.changeFooterStatus(false);
      }
    }
    static {
      this.ɵfac = function EzTableComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EzTableComponent)(i0.ɵɵdirectiveInject(i1.EZLayoutService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EzTableComponent,
        selectors: [["ez-table"]],
        viewQuery: function EzTableComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dt = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.txtGlobalFilter = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.drpTableOptions = _t.first);
          }
        },
        inputs: {
          keyField: "keyField",
          tableName: "tableName",
          showHeader: "showHeader",
          showAdd: "showAdd",
          showEdit: "showEdit",
          showDelete: "showDelete",
          showDisabledDeleteIcon: "showDisabledDeleteIcon",
          showDisabledEditIcon: "showDisabledEditIcon",
          showCopy: "showCopy",
          showFooter: "showFooter",
          showFooterTotals: "showFooterTotals",
          showExportToCsv: "showExportToCsv",
          showAllRowPerPage: "showAllRowPerPage",
          showRefreshIcon: "showRefreshIcon",
          showDeleteAction: "showDeleteAction",
          disableInLineRowEdit: "disableInLineRowEdit",
          showHiddenColumnInfo: "showHiddenColumnInfo",
          showHiddenColumnSelector: "showHiddenColumnSelector",
          filtersApplied: "filtersApplied",
          showClearFilters: "showClearFilters",
          showAdditionalFiltersBlockBelowSearchTextBox: "showAdditionalFiltersBlockBelowSearchTextBox",
          showAdditionalFiltersBlockToggleIcon: "showAdditionalFiltersBlockToggleIcon",
          showGlobalSearchField: "showGlobalSearchField",
          hasEditTemplate: "hasEditTemplate",
          priorityColumnTitle: "priorityColumnTitle",
          selectionMode: "selectionMode",
          selectedRows: "selectedRows",
          selectedDefaultTableAction: "selectedDefaultTableAction",
          columnList: "columnList",
          hideColumnList: "hideColumnList",
          doNotShowTheseColumnsOnLoad: "doNotShowTheseColumnsOnLoad",
          alwaysShownColumns: "alwaysShownColumns",
          footerTotalColumnList: "footerTotalColumnList",
          emptymessage: "emptymessage",
          globalFilterPlaceholderText: "globalFilterPlaceholderText",
          globalSearchTextMaxLengthLimit: "globalSearchTextMaxLengthLimit",
          defaultSortOrderField: "defaultSortOrderField",
          rowsCount: "rowsCount",
          defaultSortOrderFieldType: "defaultSortOrderFieldType",
          rowPerPageOptions: "rowPerPageOptions",
          enableSorting: "enableSorting",
          enablePagination: "enablePagination",
          getFooterTotalFunction: "getFooterTotalFunction",
          enableLazyLoading: "enableLazyLoading",
          totalRecords: "totalRecords",
          loading: "loading",
          doFrontEndGlobalSearch: "doFrontEndGlobalSearch",
          orderArrowsAvailable: "orderArrowsAvailable",
          showNumberOfRows: "showNumberOfRows",
          enableActionApplyUponSelection: "enableActionApplyUponSelection",
          selectAllItemsPerSinglePageOnly: "selectAllItemsPerSinglePageOnly",
          isMobileDevice: "isMobileDevice",
          isTabletDevice: "isTabletDevice",
          showSecondaryGridHeaderButton: "showSecondaryGridHeaderButton",
          showAdditionalSecondaryGridHeaderButton: "showAdditionalSecondaryGridHeaderButton",
          showPrimaryGridHeaderButton: "showPrimaryGridHeaderButton",
          secondaryGridHeaderButtonLabel: "secondaryGridHeaderButtonLabel",
          additionalSecondaryGridHeaderButtonLabel: "additionalSecondaryGridHeaderButtonLabel",
          primaryGridHeaderButtonLabel: "primaryGridHeaderButtonLabel",
          secondaryGridHeaderButtonCyName: "secondaryGridHeaderButtonCyName",
          additionalSecondaryGridHeaderButtonCyName: "additionalSecondaryGridHeaderButtonCyName",
          primaryGridHeaderButtonCyName: "primaryGridHeaderButtonCyName",
          secondaryGridHeaderButtonDisabled: "secondaryGridHeaderButtonDisabled",
          additionalSecondaryGridHeaderButtonDisabled: "additionalSecondaryGridHeaderButtonDisabled",
          primaryGridHeaderButtonDisabled: "primaryGridHeaderButtonDisabled",
          showTableName: "showTableName",
          showCustomMobileTableFooterActionsTemplate: "showCustomMobileTableFooterActionsTemplate",
          showMobileGridFooterByDefault: "showMobileGridFooterByDefault",
          originalEditRowDataForError: "originalEditRowDataForError",
          customSortColsAndFunction: "customSortColsAndFunction",
          tableActionsDisabled: "tableActionsDisabled",
          tableActions: "tableActions",
          filterColumns: "filterColumns",
          headerReplacements: "headerReplacements",
          rows: "rows",
          firstPageNumberToShow: "firstPageNumberToShow",
          reorderableRows: "reorderableRows",
          columnsOutput: "columnsOutput",
          editTemplate: "editTemplate",
          customHeadersTemplate: "customHeadersTemplate",
          customColumnsTemplate: "customColumnsTemplate",
          customColumnsTemplateNoRow: "customColumnsTemplateNoRow",
          customFooterTemplate: "customFooterTemplate",
          customEmptyMessageTemplate: "customEmptyMessageTemplate",
          customEmptyMessageTemplateNoRow: "customEmptyMessageTemplateNoRow",
          customActionsHeadersTemplate: "customActionsHeadersTemplate",
          customActionsTemplate: "customActionsTemplate",
          tableToolboxTemplate: "tableToolboxTemplate",
          customTableActionsTemplate: "customTableActionsTemplate",
          customSearchOptionsRightOfSearchTextBoxTemplate: "customSearchOptionsRightOfSearchTextBoxTemplate",
          additionalFiltersBlockBelowSearchTextBoxTemplate: "additionalFiltersBlockBelowSearchTextBoxTemplate",
          headerUpperRightIconsTemplate: "headerUpperRightIconsTemplate",
          customGlobalSearchFieldTemplate: "customGlobalSearchFieldTemplate",
          customMobileTableFooterActionsTemplate: "customMobileTableFooterActionsTemplate"
        },
        outputs: {
          rowClicked: "rowClicked",
          addClicked: "addClicked",
          editClicked: "editClicked",
          copyRowClicked: "copyRowClicked",
          editCancelClicked: "editCancelClicked",
          editSaveClicked: "editSaveClicked",
          deleteClicked: "deleteClicked",
          actionApply: "actionApply",
          selectedRowsChange: "selectedRowsChange",
          rowReorderChange: "rowReorderChange",
          colReorderChange: "colReorderChange",
          colSortedChange: "colSortedChange",
          lazyLoad: "lazyLoad",
          onPageClicked: "onPageClicked",
          onGlobalSearchTextChanged: "onGlobalSearchTextChanged",
          onColumnsChange: "onColumnsChange",
          dataAvailable: "dataAvailable",
          secondaryGridHeaderButtonClicked: "secondaryGridHeaderButtonClicked",
          additionalSecondaryGridHeaderButtonClicked: "additionalSecondaryGridHeaderButtonClicked",
          primaryGridHeaderbuttonClicked: "primaryGridHeaderbuttonClicked",
          filtersCleared: "filtersCleared"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([Table, TableService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 17,
        vars: 26,
        consts: [["dt", ""], ["numberOfResultsContainer", ""], ["tableOptionsDropdown", ""], ["additionalFiltersBlockToggleIcon", ""], ["additionalFiltersBlockBelowSearchTextBox", ""], ["defaultSearchContainer", ""], ["searchAndFilterButtonConainer", ""], ["mobileDeviceGridHeader", ""], ["ezRow", ""], ["numberOfSelectedRows", ""], ["clearSelection", ""], ["drpTableOptions", ""], ["txtGlobalFilter", ""], [3, "selectionChange", "onSort", "onFilter", "onRowSelect", "onRowUnselect", "onRowReorder", "onColReorder", "sortFunction", "onLazyLoad", "onHeaderCheckboxToggle", "onPage", "firstChange", "selection", "columns", "globalFilterFields", "value", "dataKey", "selectionMode", "reorderableColumns", "paginator", "rowsPerPageOptions", "rows", "customSort", "autoLayout", "editMode", "sortField", "sortOrder", "lazy", "totalRecords", "loading", "selectionPageOnly", "styleClass", "columnsCountClass", "frozenColumns", "dataAvailable", "first"], ["pTemplate", "caption"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "emptymessage"], [4, "ngIf"], [1, "table-name", "text-heading-2", "heading-gray"], [1, "d-flex", "justify-content-between", "flex-wrap"], [1, "d-flex", "align-items-center", "justify-content-end"], [1, "m-r-sm", "m-l-sm", "d-flex", "align-items-center"], [4, "ngTemplateOutlet"], ["pTooltip", "Refresh sorting", "tooltipPosition", "top", 3, "cssClass", "iconClass"], ["type", "button", "pButton", "", "pRipple", "", "icon", "pi pi-file-o", "pTooltip", "CSV", "tooltipPosition", "top", 1, "mr-2"], ["name", "tableSelectedColumns", "optionLabel", "header", "styleClass", "w-100 hidden-column-selector", "optionDisabled", "isDisabled", "ezSelectPanelShowDirection", "", 3, "ngModel", "options", "selectedItemsLabel", "placeholder", "overlayOptions"], [1, "col", "d-flex", "pl-0", "pr-0", "text-left", "align-items-center", "flex-wrap"], [1, "mr-2", 3, "disabled"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "cyName", "cssClass", "disabled", "label"], [3, "click", "cyName", "cssClass", "disabled", "label"], [1, "table-name", "m-0", "text-heading-2", "heading-gray"], ["pTooltip", "Refresh sorting", "tooltipPosition", "top", 3, "click", "cssClass", "iconClass"], ["type", "button", "pButton", "", "pRipple", "", "icon", "pi pi-file-o", "pTooltip", "CSV", "tooltipPosition", "top", 1, "mr-2", 3, "click"], ["name", "tableSelectedColumns", "optionLabel", "header", "styleClass", "w-100 hidden-column-selector", "optionDisabled", "isDisabled", "ezSelectPanelShowDirection", "", 3, "ngModelChange", "onChange", "ngModel", "options", "selectedItemsLabel", "placeholder", "overlayOptions"], [4, "ngIf", "ngIfElse"], [1, "mobile-device-grid-header", "d-flex", 3, "ngClass"], [1, "grid-header-buttons-container", "d-flex"], [3, "cyName", "disabled", "label", "click", 4, "ngIf"], [3, "click", "cyName", "disabled", "label"], [1, "col", "d-flex", "p-0", "search-and-filter-button-container", 3, "ngClass"], ["class", "reordable-icon-col", 4, "ngIf"], ["class", "first-column-select", "pFrozenColumn", "", "alignFrozen", "left", 3, "ngClass", "ngStyle", 4, "ngIf"], ["pResizableColumn", "", "pReorderableColumn", "", 3, "pSortableColumn", "class", 4, "ngFor", "ngForOf"], ["class", "action-column", "pFrozenColumn", "", "alignFrozen", "right", 4, "ngIf"], [1, "reordable-icon-col"], ["pFrozenColumn", "", "alignFrozen", "left", 1, "first-column-select", 3, "ngClass", "ngStyle"], [3, "ngClass", "disabled", 4, "ngIf"], [3, "ngClass", "disabled"], [1, "action-column", "reorder-column"], ["pResizableColumn", "", "pReorderableColumn", "", 3, "pSortableColumn"], [1, "header-container"], [1, "column-header-text"], [3, "field", 4, "ngIf"], [3, "field"], ["pFrozenColumn", "", "alignFrozen", "right", 1, "action-column"], ["pTooltip", "Add item", "tooltipPosition", "top", 3, "click", "cssClass", "iconClass", "isSecondaryButton", "isIconOnly"], ["style", "width:2.5em", 4, "ngIf"], ["class", "first-column-select", 4, "ngIf"], ["pResizableColumn", "", "tooltipPosition", "top", 3, "pTooltip", "showDelay", 4, "ngFor", "ngForOf"], ["class", "action-column", 4, "ngIf"], [2, "width", "2.5em"], [1, "first-column-select"], ["pResizableColumn", "", "tooltipPosition", "top", 3, "pTooltip", "showDelay"], [1, "action-column"], [3, "pEditableRow", "pReorderableRow", 4, "ngIf"], [3, "pEditableRow", 4, "ngIf"], [3, "pEditableRow", "pReorderableRow"], ["class", "first-column-select", "pFrozenColumn", "", "alignFrozen", "left", 4, "ngIf"], ["pReorderableRowHandle", "", 1, "d-flex", "justify-content-center", "ez-table-reorder-icon"], ["pFrozenColumn", "", "alignFrozen", "left", 1, "first-column-select"], [3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], ["class", "link", 3, "click", 4, "ngSwitchCase"], [3, "value", "click", 4, "ngSwitchCase"], [3, "value", "disabled", 4, "ngSwitchDefault"], [1, "link", 3, "click"], [3, "click", "value"], [3, "value", "disabled"], [1, "order-btn"], [1, "d-flex", "align-items-center"], [1, "d-flex", "flex-column"], [1, "ez-icon", "arrow-up-2pt", "mb-1", 3, "click", "ngClass"], [1, "ez-icon", "arrow-down-2pt", 3, "click", "ngClass"], [1, "row-index"], [3, "ngSwitch", "class", 4, "ngFor", "ngForOf"], ["class", "p-resizable-column", 3, "ngSwitch", 4, "ngFor", "ngForOf"], [1, "p-resizable-column", 3, "ngSwitch"], ["class", "link", 4, "ngIf"], [1, "link"], [3, "hasCustomizedContent", "tooltipPosition"], [3, "innerHtml", 4, "ngFor", "ngForOf"], [3, "innerHtml"], ["pInitEditableRow", "", 3, "isSecondaryButton", "isIconOnly", "cssClass", "iconClass", "disabled", "click", 4, "ngIf"], ["pCancelEditableRow", "", 3, "isSecondaryButton", "isIconOnly", "cssClass", "iconClass", "click", 4, "ngIf"], ["pInitEditableRow", "", 3, "click", "isSecondaryButton", "isIconOnly", "cssClass", "iconClass", "disabled"], ["pCancelEditableRow", "", 3, "click", "isSecondaryButton", "isIconOnly", "cssClass", "iconClass"], ["pSaveEditableRow", "", 3, "isSecondaryButton", "isIconOnly", "cssClass", "iconClass", "click", 4, "ngIf"], ["pSaveEditableRow", "", 3, "click", "isSecondaryButton", "isIconOnly", "cssClass", "iconClass"], [3, "click", "isSecondaryButton", "isIconOnly", "cssClass", "iconClass"], [3, "click", "cssClass", "isSecondaryButton", "isIconOnly", "iconClass", "disabled"], [3, "pEditableRow"], [3, "colSpan"], ["pTemplate", "footer"], [4, "ngFor", "ngForOf"], [1, "table-mobile-footer-container", 3, "ngClass"], [1, "default-table-mobile-footer-container", "d-flex", "justify-content-between"], [3, "click", "cssClass", "iconClass", "isIconOnly", "isSecondaryButton"], [3, "click", "cssClass", "iconClass", "isPrimaryButton", "isIconOnly", "isSecondaryButton", "isActiveButton"], [1, "d-flex", "number-of-results-container", 3, "ngClass"], [1, "heading-gray", "mb-0", 3, "ngClass"], [1, "heading-green", "cursor-pointer", "ml-2", 3, "click"], [1, "text-heading-2", "heading-gray", "mb-0", 3, "ngClass"], [1, "ml-2"], [1, "heading-green", "cursor-pointer", 3, "click"], ["name", "drpTableOptions", "optionLabel", "label", "optionValue", "value", "ezSelectPanelShowDirection", "", 3, "ngModelChange", "onChange", "onShow", "onHide", "options", "disabled", "showClear", "ngModel", "placeholder", "overlayOptions", "addCloseButton"], [3, "click", "cyName", "cssClass", "iconClass", "isPrimaryButton", "isIconOnly", "isSecondaryButton", "isActiveButton"], [1, "additional-filters-block", 3, "hidden", "ngClass"], ["layout", "horizontal"], [1, "search-container", "mr-2", "p-input-icon-right", 3, "ngClass"], [1, "black-icon", "ez-icon", "icon-medium", 3, "click", "ngClass"], ["ezInputWidthByPlaceholder", "", "pInputText", "", "type", "text", 1, "w-100", 3, "input", "title", "placeholder"]],
        template: function EzTableComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "p-table", 13, 0);
            i0.ɵɵtwoWayListener("selectionChange", function EzTableComponent_Template_p_table_selectionChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.selectedRows, $event) || (ctx.selectedRows = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("onSort", function EzTableComponent_Template_p_table_onSort_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSort($event));
            })("onFilter", function EzTableComponent_Template_p_table_onFilter_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFilter($event));
            })("onRowSelect", function EzTableComponent_Template_p_table_onRowSelect_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelectedRow($event));
            })("onRowUnselect", function EzTableComponent_Template_p_table_onRowUnselect_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelectedRow($event));
            })("onRowReorder", function EzTableComponent_Template_p_table_onRowReorder_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onRowReorder($event));
            })("onColReorder", function EzTableComponent_Template_p_table_onColReorder_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onColReorder($event));
            })("sortFunction", function EzTableComponent_Template_p_table_sortFunction_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.customSort($event));
            })("onLazyLoad", function EzTableComponent_Template_p_table_onLazyLoad_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onLazyLoad($event));
            })("onHeaderCheckboxToggle", function EzTableComponent_Template_p_table_onHeaderCheckboxToggle_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onHeaderCheckboxToggle());
            })("onPage", function EzTableComponent_Template_p_table_onPage_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onPage($event));
            });
            i0.ɵɵtwoWayListener("firstChange", function EzTableComponent_Template_p_table_firstChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx._firstPageNumberToShow, $event) || (ctx._firstPageNumberToShow = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵtemplate(2, EzTableComponent_ng_template_2_Template, 6, 4, "ng-template", 14)(3, EzTableComponent_ng_template_3_Template, 3, 6, "ng-template", 15)(4, EzTableComponent_ng_template_4_Template, 2, 2, "ng-template", 16)(5, EzTableComponent_ng_template_5_Template, 1, 1, "ng-template", 17)(6, EzTableComponent_6_Template, 1, 0, null, 18)(7, EzTableComponent_ng_template_7_Template, 4, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(9, EzTableComponent_ng_template_9_Template, 3, 11, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(11, EzTableComponent_ng_template_11_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(13, EzTableComponent_ng_template_13_Template, 3, 7, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(15, EzTableComponent_ng_template_15_Template, 4, 11, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵtwoWayProperty("selection", ctx.selectedRows);
            i0.ɵɵproperty("columns", ctx.selectedColumns)("globalFilterFields", ctx._filterColumns)("value", ctx._rows)("dataKey", ctx.keyField)("selectionMode", ctx.selectionMode === "multiple" ? "multiple" : "single")("reorderableColumns", ctx._reorderableRows)("paginator", ctx.enablePagination)("rowsPerPageOptions", ctx.rowPerPageOptions)("rows", ctx.isMobileDevice ? 10 : ctx.rowsCount)("customSort", ctx.hasCustomSort)("autoLayout", true)("editMode", ctx.disableInLineRowEdit ? "cell" : "row")("sortField", ctx.sortField)("sortOrder", ctx.sortOrder)("lazy", ctx.enableLazyLoading)("totalRecords", ctx.totalRecords)("loading", ctx.loading)("selectionPageOnly", ctx.selectAllItemsPerSinglePageOnly)("styleClass", ctx._reorderableRows && !ctx.colIsSorted && ctx.orderArrowsAvailable ? "reorderable-rows" : "")("columnsCountClass", ctx.selectedColumns)("frozenColumns", ctx.frozenColumns)("dataAvailable", ctx.dataAvailable);
            i0.ɵɵtwoWayProperty("first", ctx._firstPageNumberToShow);
            i0.ɵɵattribute("data-cy", ctx.tableNamePrefix);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngIf", ctx.showFooter);
          }
        },
        dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgStyle, i2.NgSwitch, i2.NgSwitchCase, i2.NgSwitchDefault, i3.NgControlStatus, i3.NgModel, i4.EzPrimaryButtonComponent, i4.EzSecondaryButtonComponent, i4.EzButtonIconComponent, i5.PrimeTemplate, i6.Table, i6.SortableColumn, i6.FrozenColumn, i6.ResizableColumn, i6.ReorderableColumn, i6.SortIcon, i6.TableRadioButton, i6.TableCheckbox, i6.TableHeaderCheckbox, i6.ReorderableRowHandle, i6.ReorderableRow, i6.EditableRow, i6.InitEditableRow, i6.SaveEditableRow, i6.CancelEditableRow, i7.Ripple, i8.Tooltip, i9.MultiSelect, i10.ButtonDirective, i11.InputText, i12.EzTooltipComponent, i13.Divider, i14.EzSelectOverlayDirective, i14.EzInputWidthByPlaceholderDirective, i15.Select, ColumnsCountClassDirective, FrozenColumnsDirective, i2.LowerCasePipe, i18.EzLocalePipe, i19.EzUncamelcasePipe, i19.EzLongToDotsPipe],
        encapsulation: 2
      });
    }
  };
  EzTableComponent = __decorate([UntilDestroy()], EzTableComponent);
  return EzTableComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EzTableTreeComponent = /*#__PURE__*/(() => {
  let EzTableTreeComponent = class EzTableTreeComponent extends EzTable {
    set originalEditRowDataForError(originalRow) {
      //if there was a validation error for the row when saving...
      if (originalRow !== null) {
        //get the original values from before the edit (table is responsible for passing that in)
        this.originalEditRowWithError = originalRow;
        //get the new/edited values
        const row = this._rows.find(x => x[this.keyField] == originalRow[this.keyField]);
        // this.dt.initRowEdit(row);
        this.onEdit(row);
      }
      //else, the error row is being cleared
      else {
        //if we have the original edit row from a previous validation error, cancel the edit
        if (this.originalEditRowWithError) {
          this.clonedRow = this.originalEditRowWithError;
          // this.dt.cancelRowEdit(this.originalEditRowWithError[this.keyField]);
          this.originalEditRowWithError = null;
        }
      }
    }
    set customSortColsAndFunction({
      colsArray,
      callBackFunction
    }) {
      if (colsArray && colsArray.length > 0 && callBackFunction) {
        this.hasCustomSort = true;
        this._customSortColumns = colsArray;
        this._customSortFunction = callBackFunction;
      } else {
        throw new Error('DEVELOPER!, Please provide a array of column names and the call back function to use for sorting.');
      }
    }
    set tableActions(actions) {
      this._tableActions = actions;
    }
    set filterColumns(filterColumns) {
      if (filterColumns) {
        this._customFilterColumns = filterColumns;
      }
    }
    set rows(value) {
      if (value) {
        this._rows = value;
        this.rowsStream.next(value);
      }
    }
    constructor(cdr) {
      super();
      this.cdr = cdr;
      this.showHeader = false;
      this.showAdd = false;
      this.showEdit = false;
      this.showDelete = false;
      this.showCopy = false;
      this.showFooterTotals = false;
      this.showExportToCsv = false;
      this.showAllRowPerPage = false;
      this.showRefreshIcon = false;
      this.showDeleteAction = false;
      this.disableInLineRowEdit = false;
      this.showHiddenColumnInfo = true;
      this.showPrimaryGridHeaderButton = false;
      this.hasEditTemplate = false;
      this.selectedRows = [];
      this.selectedDefaultTableAction = null;
      this.doNotShowTheseColumnsOnLoad = [];
      this.footerTotalColumnList = [];
      this.emptymessage = ResourcesProvider.rks.NoRecordsFound;
      this.tableName = '';
      this.showGlobalSearchField = false;
      this.globalFilterPlaceholderText = ResourcesProvider.rks.Search;
      this.rowsCount = 20;
      this.globalSearchTextMaxLengthLimit = 0;
      this.defaultSortOrderFieldType = 1;
      this.showDisabledDeleteIcon = false;
      this.showFooter = true;
      this.showHiddenColumnSelector = true;
      this.showAdditionalFiltersBlockBelowSearchTextBox = false;
      this.showAdditionalFiltersBlockToggleIcon = false;
      this.reorderableRows = false;
      this.headerReplacements = [];
      this.enableSorting = true;
      this.enablePagination = true;
      this.getFooterTotalFunction = null;
      this.enableLazyLoading = false;
      this.totalRecords = 0;
      this.loading = false;
      this.tableStyleClass = '';
      this.enableActionApplyUponSelection = true;
      this._customSortColumns = [];
      this.tableActionsDisabled = false;
      this._customFilterColumns = [];
      // - Event Outputs - //
      this.rowClicked = new EventEmitter();
      this.addClicked = new EventEmitter();
      this.editClicked = new EventEmitter();
      this.copyRowClicked = new EventEmitter();
      this.editCancelClicked = new EventEmitter();
      this.editSaveClicked = new EventEmitter();
      this.deleteClicked = new EventEmitter();
      this.actionApply = new EventEmitter();
      this.selectedRowsChange = new EventEmitter();
      this.rowReorderChange = new EventEmitter();
      this.colReorderChange = new EventEmitter();
      this.colSortedChange = new EventEmitter();
      this.lazyLoad = new EventEmitter();
      this.onGlobalSearchTextChanged = new EventEmitter();
      this._tableActions = [];
      this._filterColumns = [];
      this.cols = [];
      this.selectedAction = null;
      this.unSelectedColumns = [];
      this.setDefaultShowingColumns = true;
      this.rowEdit = false;
      this.hasFooter = false;
      this.uncamelcasePipe = new EzUncamelcasePipe();
      this.hasCustomSort = false;
      this.rowPerPageOptions = [10, 20, 50, 100];
      this.sortField = null;
      this.sortOrder = 1;
      this.colIsSorted = false;
      this.EZCheckboxRowSelected = false;
      this.filteredNodesList = [];
      this.hiddenColumnListStream = new BehaviorSubject([]);
      this.rowsStream = new BehaviorSubject([]);
      this.numberOfFilteredRows = null;
      // - passable functions for Edit - //
      this.cancelEdit = rowIndex => {
        this.onEditCancel(rowIndex);
      };
      this.saveEdit = (dataRow, ri) => {
        this.onEditSave(dataRow, ri);
      };
    }
    ngAfterViewInit() {
      this.setFilters();
      this.setDefaultSortOrder();
    }
    ngOnInit() {
      if (this.customFooterTemplate) {
        this.hasFooter = true;
      }
      if (this.showDeleteAction) {
        this._tableActions.push({
          label: 'Delete',
          value: 'delete'
        });
      }
      this.tableNamePrefix = 'table' + (this.tableName ? '-' + toCypressName(this.tableName) : '');
      this.initColumnsConfiguration();
    }
    ngOnChanges(changes) {
      if (changes.hideColumnList && changes.hideColumnList.currentValue) {
        this.hiddenColumnListStream.next(changes.hideColumnList.currentValue);
      }
    }
    initColumnsConfiguration() {
      combineLatest([this.hiddenColumnListStream, this.rowsStream]).pipe(untilDestroyed(this)).subscribe(([hiddenColumnList, rows]) => {
        this.setFilteredNodes(rows);
        this.numberOfFilteredRows = Array.isArray(rows) ? rows.length : 0;
        if (rows && rows.length > 0 && this.cols.length === 0) {
          const row = rows[0].data;
          let position = 0;
          for (const field in row) {
            if (field !== this.keyField && hiddenColumnList.indexOf(field) < 0) {
              const header = {
                field: field,
                header: this.uncamelcasePipe.transform(field),
                position: position
              };
              this.cols.push(header);
              position++;
            }
          }
          // ------------------------------------------------- //
          // this will set the columns not to show when the table is first loaded
          if (this.setDefaultShowingColumns) {
            if (this.cols.length && this.doNotShowTheseColumnsOnLoad.length) {
              this.selectedColumns = this.cols.filter(col => !this.doNotShowTheseColumnsOnLoad.includes(col.field));
              this.unSelectedColumns = this.cols.filter(col => this.doNotShowTheseColumnsOnLoad.includes(col.field));
              this.setDefaultShowingColumns = false;
            } else {
              this.selectedColumns = this.cols;
            }
          }
          this.setFilters();
          this.updateRowsPerPageOptions();
          this.setDefaultSortOrder();
          this.setDefaultSelectedMultipleTableAction();
          this.cdr.markForCheck();
        }
      });
    }
    setFilteredNodes(rows) {
      this.filteredNodesList = [];
      this.findFilteredNodes(rows);
    }
    findFilteredNodes(rows) {
      rows.map(row => {
        this.filteredNodesList.push(row);
        if (row.children && row.children.length > 0) {
          this.findFilteredNodes(row.children);
        }
      });
    }
    updateRowsPerPageOptions() {
      if (this.showAllRowPerPage) {
        this.rowPerPageOptions = this._rows.length > 100 ? [...this.rowPerPageOptions, this._rows.length] : this.rowPerPageOptions;
      }
    }
    setFilters() {
      if (this.showGlobalSearchField && this._customFilterColumns.length === 0 && this.selectedColumns) {
        // set collection to columns that are visible and available to be visible
        // const searchableColumns = this.unSelectedColumns.concat(this.selectedColumns);
        // const x = Object.keys(searchableColumns).map(f => searchableColumns[f].field);
        // this._filterColumns = x;
        this._filterColumns = Object.keys(this.selectedColumns).map(f => this.selectedColumns[f].field);
      }
    }
    globalFilter(eventTarget, table) {
      const searchText = eventTarget.value;
      if (this.checkGlobalSearchTextLimit(searchText)) {
        table.filterGlobal(eventTarget.value, 'contains');
      }
      this.onGlobalSearchTextChanged.emit(searchText);
    }
    checkGlobalSearchTextLimit(searchText) {
      const searchTextLength = searchText.length;
      if (this.globalSearchTextMaxLengthLimit && searchTextLength > this.globalSearchTextMaxLengthLimit) {
        alert('Search text length limit');
        return false;
      }
      return true;
    }
    onLazyLoad(lazyLoadEvent) {
      this.lazyLoad.emit(lazyLoadEvent);
    }
    onTableFiltered(filterEvent) {
      this.setFilteredNodes(filterEvent.filteredValue);
    }
    onEZCheckboxHeaderSelect(checked) {
      this.EZCheckboxRowSelected = checked;
      this.selectedRows = checked ? [...this.filteredNodesList] : [];
      /**
       * Fix necessary for Prime NG To update the Table Selection
       */
      this._rows = Object.assign([], this._rows);
    }
    onEZCheckboxRowSelect(checked, row) {
      /**
       * Manual update this.selectedRows array for custom ez-checkbox selection mode
       * Run this.onSelectedRow(row) only if row was checked.
       * If unchecked, then only remove unchecked row from this.selectedRows
       */
      if (checked) {
        this.selectedRows = [...this.selectedRows, row];
        this.onSelectedRow(row);
      } else {
        this.selectedRows = this.selectedRows.filter(selectedRow => selectedRow.data[this.keyField] !== row.data[this.keyField]);
      }
    }
    // public function for consumers to use to manually clear the selected rows
    clearSelectedRows() {
      this.selectedRows = [];
      this.selectedRowsChange.emit([]);
      /**
       * Fix necessary for Prime NG To update the Table Selection
       */
      this._rows = Object.assign([], this._rows);
    }
    onSelectedRow(row) {
      this.rowClicked.emit(row.data);
      this.selectedRowsChange.emit(this.selectedRows.map(row => row));
    }
    onActionSelected(action) {
      if ((action.value || action.value === 0) && this.enableActionApplyUponSelection) {
        this.onActionApply();
      }
    }
    onActionApply() {
      if (this.selectedAction !== null) {
        const request = {
          action: this.selectedAction,
          rows: this.selectedRows.map(row => row.data)
        };
        this.actionApply.emit(request);
        // It is necessary to clear selected action otherwise
        // user will have to manually clear and select it again in order for action to work
        this.drpTableOptions.clear();
      }
    }
    onAddItemClick() {
      this.addClicked.emit();
    }
    onDelete(row) {
      this.deleteClicked.emit(row);
    }
    onCopyRow(row) {
      // may need a deep copy
      this.clonedRow = {
        ...row
      };
      this.copyRowClicked.emit(row);
    }
    onEdit(row) {
      // check if we need to show in line editing icons
      if (!this.disableInLineRowEdit) {
        // may need a deep copy
        this.rowEdit = true;
        this.clonedRow = {
          ...row
        };
      }
      this.editClicked.emit(row);
    }
    onEditCancel(rowIndex) {
      this.rowEdit = false;
      if (this.originalEditRowWithError) {
        //set the original data back into the clone row.
        //we need this because the clonedRow data was changing as the values changed while in edit mode
        this.clonedRow = this.originalEditRowWithError;
        this.originalEditRowWithError = null;
      }
      this._rows[rowIndex] = this.clonedRow;
      this.clonedRow = null;
      this.editCancelClicked.emit();
    }
    onEditSave(row, ri) {
      this.clonedRow = null;
      this.rowEdit = false;
      this.editSaveClicked.emit(row);
      this._rows[ri] = row;
    }
    onHideEdit(tr) {
      const editButton = tr.children["editColumn"].children["editButton"];
      if (editButton) {
        editButton.hidden = true;
      }
    }
    isTotalColumn(colName) {
      const column = this.footerTotalColumnList.find(tc => tc === colName);
      return !!(column && this.getFooterTotalFunction);
    }
    getColumnTotal(column) {
      return this.getFooterTotalFunction(this._rows, column);
    }
    highlightThisRow(tr) {
      return color => {
        if (!tr.classList.contains(color)) {
          tr.classList.add(color);
        }
      };
    }
    highlightIf(tr, cssClass) {
      return exp => {
        if (exp) {
          if (!tr.classList.contains(cssClass)) {
            tr.classList.add(cssClass);
          }
        } else {
          tr.classList.remove(cssClass);
        }
      };
    }
    editRow(rowData) {
      return () => {
        this.onEdit(rowData);
      };
    }
    cancelEditRow(rowIndex) {
      return () => {
        this.onEditCancel(rowIndex);
      };
    }
    saveEditRow(rowData, rowIndex) {
      return () => {
        this.onEditSave(rowData, rowIndex);
      };
    }
    hideEdit(tr) {
      return () => {
        this.onHideEdit(tr);
      };
    }
    onColReorder(colReorderEvent) {
      this.rowReorderChange.emit(colReorderEvent);
    }
    onSort(colSortedEvent) {
      this.sortField = colSortedEvent.field;
      this.sortOrder = colSortedEvent.order;
      // if the grid is now sorted by the default sort field and sort order,
      // then the grid is not "sorted" in that its the default sort and drag and drop should be allowed
      if (this.sortField === this.defaultSortOrderField && this.sortOrder === 1) {
        this.colIsSorted = false;
      } else {
        this.colIsSorted = true;
      }
      this.colSortedChange.emit(colSortedEvent);
    }
    customSort(event) {
      event.data?.sort((data1, data2) => {
        if (this.hasCustomSort && this._customSortColumns.indexOf(event.field) >= 0) {
          // event order is whether its asc (1) or desc(-1)
          const customOrder = this._customSortFunction(event.field, data1, data2);
          return event.order * customOrder;
        } else {
          const value1 = data1[event.field];
          const value2 = data2[event.field];
          let result;
          if (value1 == null && value2 != null) {
            result = -1;
          } else if (value1 != null && value2 == null) {
            result = 1;
          } else if (value1 == null && value2 == null) {
            result = 0;
          } else if (typeof value1 === 'string' && typeof value2 === 'string') {
            result = value1.localeCompare(value2);
          } else {
            result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
          }
          return event.order * result;
        }
      });
    }
    setDefaultSortOrder() {
      if (this.dt && !this.enableLazyLoading) {
        this.dt.reset();
        this.sortOrder = this.defaultSortOrderFieldType;
        this.dt.sortOrder = this.defaultSortOrderFieldType;
        this.colIsSorted = false;
        if (this.defaultSortOrderField) {
          this.sortField = this.defaultSortOrderField;
          this.dt.sortField = this.defaultSortOrderField;
        } else {
          this.sortField = null;
          this.dt.sortField = null;
        }
      }
    }
    setDefaultSelectedMultipleTableAction() {
      this.selectedAction = this.selectedDefaultTableAction !== null ? this.selectedDefaultTableAction : null;
    }
    onRefreshTableClick() {
      if (this.sortOrder !== 1 || !this.defaultSortOrderField && this.sortField || this.defaultSortOrderField && this.sortField !== this.defaultSortOrderField) {
        this.setDefaultSortOrder();
      }
    }
    onSelectedColumnsChange(selectedCols) {
      this.unSelectedColumns = this.cols.filter(col => !selectedCols.map(selectedCol => selectedCol.field).includes(col.field));
      this.selectedColumns.sort(this.sortPosition);
      this.setFilters();
      this.globalFilter(this.txtGlobalFilter.nativeElement, this.dt);
    }
    onAdditionalFiltersBlockToggleIconClick() {
      this.showAdditionalFiltersBlockBelowSearchTextBox = !this.showAdditionalFiltersBlockBelowSearchTextBox;
    }
    outputUnselectedColumnData(rowData, col) {
      let output = '';
      if (rowData[col.field]) {
        output = '<strong>' + col.header + ':</strong> ' + rowData[col.field];
      }
      return output;
    }
    hiddenInfoColumnHasData(rowData) {
      let hasInfo = false;
      for (const col of this.unSelectedColumns) {
        if (rowData[col.field]) {
          hasInfo = true;
          break;
        }
      }
      return hasInfo;
    }
    replaceHeaderText(prop) {
      let headerText = prop;
      if (this.headerReplacements.length) {
        const header = this.headerReplacements.find(value => value.value === prop);
        headerText = header ? header.label : headerText;
      }
      return headerText;
    }
    cypressRowId(controlTypeDescription, rowData, rowIndex) {
      const rowId = controlTypeDescription + (this.keyField ? '-' + this.keyField.toLowerCase() + '-' + rowData[this.keyField] : '-row-id-' + rowIndex);
      return this.tableNamePrefix + '-' + rowId;
    }
    static {
      this.ɵfac = function EzTableTreeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EzTableTreeComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EzTableTreeComponent,
        selectors: [["ez-table-tree"]],
        viewQuery: function EzTableTreeComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dt = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.txtGlobalFilter = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.drpTableOptions = _t.first);
          }
        },
        inputs: {
          keyField: "keyField",
          showHeader: "showHeader",
          showAdd: "showAdd",
          showEdit: "showEdit",
          showDelete: "showDelete",
          showCopy: "showCopy",
          showFooterTotals: "showFooterTotals",
          showExportToCsv: "showExportToCsv",
          showAllRowPerPage: "showAllRowPerPage",
          showRefreshIcon: "showRefreshIcon",
          showDeleteAction: "showDeleteAction",
          disableInLineRowEdit: "disableInLineRowEdit",
          showHiddenColumnInfo: "showHiddenColumnInfo",
          showPrimaryGridHeaderButton: "showPrimaryGridHeaderButton",
          hasEditTemplate: "hasEditTemplate",
          selectionMode: "selectionMode",
          selectedRows: "selectedRows",
          selectedDefaultTableAction: "selectedDefaultTableAction",
          columnList: "columnList",
          doNotShowTheseColumnsOnLoad: "doNotShowTheseColumnsOnLoad",
          hideColumnList: "hideColumnList",
          footerTotalColumnList: "footerTotalColumnList",
          emptymessage: "emptymessage",
          tableName: "tableName",
          showGlobalSearchField: "showGlobalSearchField",
          globalFilterPlaceholderText: "globalFilterPlaceholderText",
          rowsCount: "rowsCount",
          globalSearchTextMaxLengthLimit: "globalSearchTextMaxLengthLimit",
          defaultSortOrderField: "defaultSortOrderField",
          defaultSortOrderFieldType: "defaultSortOrderFieldType",
          showDisabledDeleteIcon: "showDisabledDeleteIcon",
          showFooter: "showFooter",
          showHiddenColumnSelector: "showHiddenColumnSelector",
          showAdditionalFiltersBlockBelowSearchTextBox: "showAdditionalFiltersBlockBelowSearchTextBox",
          showAdditionalFiltersBlockToggleIcon: "showAdditionalFiltersBlockToggleIcon",
          reorderableRows: "reorderableRows",
          headerReplacements: "headerReplacements",
          enableSorting: "enableSorting",
          enablePagination: "enablePagination",
          getFooterTotalFunction: "getFooterTotalFunction",
          enableLazyLoading: "enableLazyLoading",
          totalRecords: "totalRecords",
          loading: "loading",
          tableStyleClass: "tableStyleClass",
          enableActionApplyUponSelection: "enableActionApplyUponSelection",
          originalEditRowDataForError: "originalEditRowDataForError",
          customSortColsAndFunction: "customSortColsAndFunction",
          tableActionsDisabled: "tableActionsDisabled",
          tableActions: "tableActions",
          filterColumns: "filterColumns",
          rows: "rows",
          columnsOutput: "columnsOutput",
          editTemplate: "editTemplate",
          customHeadersTemplate: "customHeadersTemplate",
          customColumnsTemplate: "customColumnsTemplate",
          customColumnsTemplateNoRow: "customColumnsTemplateNoRow",
          customFooterTemplate: "customFooterTemplate",
          customEmptyMessageTemplate: "customEmptyMessageTemplate",
          customEmptyMessageTemplateNoRow: "customEmptyMessageTemplateNoRow",
          customActionsHeadersTemplate: "customActionsHeadersTemplate",
          customActionsTemplate: "customActionsTemplate",
          tableToolboxTemplate: "tableToolboxTemplate",
          customTableActionsTemplate: "customTableActionsTemplate",
          customSearchOptionsTemplate: "customSearchOptionsTemplate",
          headerUpperRightIconsTemplate: "headerUpperRightIconsTemplate",
          customSearchOptionsRightOfSearchTextBoxTemplate: "customSearchOptionsRightOfSearchTextBoxTemplate",
          additionalFiltersBlockBelowSearchTextBoxTemplate: "additionalFiltersBlockBelowSearchTextBoxTemplate"
        },
        outputs: {
          rowClicked: "rowClicked",
          addClicked: "addClicked",
          editClicked: "editClicked",
          copyRowClicked: "copyRowClicked",
          editCancelClicked: "editCancelClicked",
          editSaveClicked: "editSaveClicked",
          deleteClicked: "deleteClicked",
          actionApply: "actionApply",
          selectedRowsChange: "selectedRowsChange",
          rowReorderChange: "rowReorderChange",
          colReorderChange: "colReorderChange",
          colSortedChange: "colSortedChange",
          lazyLoad: "lazyLoad",
          onGlobalSearchTextChanged: "onGlobalSearchTextChanged"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([TreeTable, TableService]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 11,
        vars: 20,
        consts: [["dt", ""], ["additionalFiltersBlockBelowSearchTextBox", ""], ["numberOfResultsContainer", ""], ["drpTableOptions", ""], ["txtGlobalFilter", ""], ["ezRow", ""], [3, "onSort", "onNodeSelect", "onColReorder", "sortFunction", "onLazyLoad", "onFilter", "columns", "globalFilterFields", "value", "dataKey", "selectionMode", "reorderableColumns", "resizableColumns", "paginator", "rowsPerPageOptions", "rows", "customSort", "autoLayout", "sortField", "sortOrder", "lazy", "totalRecords", "loading", "styleClass"], ["pTemplate", "caption"], ["pTemplate", "header"], ["pTemplate", "body"], [4, "ngIf"], ["pTemplate", "emptymessage"], ["class", "row", 4, "ngIf"], [4, "ngTemplateOutlet"], [1, "row"], [1, "table-name", "text-heading-3", "heading-gray"], [1, "d-flex", "justify-content-between", "flex-wrap"], [1, "col", "d-flex", "align-items-center", "text-left"], [1, "col", "d-flex", "justify-content-center", "flex-1"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "d-flex", "align-items-center", "justify-content-end"], [1, "m-r-sm", "m-l-sm", "d-flex", "align-items-center"], ["name", "tableSelectedColumns", "optionLabel", "header", "styleClass", "w-100 hidden-column-selector", "optionDisabled", "isDisabled", "ezSelectPanelShowDirection", "", 3, "ngModel", "options", "selectedItemsLabel", "placeholder", "overlayOptions"], [2, "display", "inline-block", 3, "ngClass"], [3, "valueChanged", "binary"], ["name", "drpTableOptions", "optionLabel", "label", "optionValue", "value", "ezSelectPanelShowDirection", "", 3, "ngModelChange", "onChange", "options", "disabled", "ngModel", "placeholder", "overlayOptions"], [3, "click", "cyName", "cssClass", "disabled", "label"], [1, "search-container", "mr-2", "p-input-icon-right"], [1, "pi", "pi-search"], ["ezInputWidthByPlaceholder", "", "pInputText", "", "type", "text", 1, "w-100", 3, "input", "title", "placeholder"], [3, "click", "cyName", "cssClass", "iconClass", "isPrimaryButton", "isSecondaryButton", "isActiveButton"], [1, "table-name", "m-0", "text-heading-3", "heading-gray"], ["pTooltip", "Refresh sorting", "tooltipPosition", "top", 3, "click", "cssClass", "iconClass"], ["name", "tableSelectedColumns", "optionLabel", "header", "styleClass", "w-100 hidden-column-selector", "optionDisabled", "isDisabled", "ezSelectPanelShowDirection", "", 3, "ngModelChange", "onChange", "ngModel", "options", "selectedItemsLabel", "placeholder", "overlayOptions"], ["style", "width:2.5em", 4, "ngIf"], ["class", "header-container", "ttResizableColumn", "", "ttReorderableColumn", "", 3, "ttSortableColumn", 4, "ngFor", "ngForOf"], ["class", "action-column", 4, "ngIf"], [2, "width", "2.5em"], ["ttResizableColumn", "", "ttReorderableColumn", "", 1, "header-container", 3, "ttSortableColumn"], [1, "column-header-text"], ["ariaLabelDesc", "Activate to sort in descending order", "ariaLabelAsc", "Activate to sort in ascending order", 3, "field", 4, "ngIf"], ["ariaLabelDesc", "Activate to sort in descending order", "ariaLabelAsc", "Activate to sort in ascending order", 3, "field"], [1, "action-column"], ["pTooltip", "Add item", "tooltipPosition", "top", 3, "click", "iconClass"], ["pResizableColumn", "", 4, "ngFor", "ngForOf"], ["pResizableColumn", ""], [3, "ttRow", 4, "ngIf"], [3, "ttRow"], ["name", "editColumn", "class", "action-column", 4, "ngIf"], ["class", "p-resizable-column", 3, "ngSwitch", "ngClass", 4, "ngFor", "ngForOf"], [1, "p-resizable-column", 3, "ngSwitch", "ngClass"], [3, "rowNode", "marginLeft", 4, "ngIf"], [3, "value", "disabled", 4, "ngIf"], [3, "selected", "binary", "disabled", "valueChanged", 4, "ngIf"], [3, "rowNode"], [3, "value", "disabled"], [3, "valueChanged", "selected", "binary", "disabled"], ["class", "p-resizable-column", 3, "ngSwitch", 4, "ngFor", "ngForOf"], [1, "p-resizable-column", 3, "ngSwitch"], ["class", "link", 4, "ngIf"], [1, "link"], [3, "hasCustomizedContent", "tooltipPosition"], [3, "innerHtml", 4, "ngFor", "ngForOf"], [3, "innerHtml"], [3, "click", "isSecondaryButton", "cssClass", "isIconOnly", "iconClass"], ["name", "editColumn", 1, "action-column"], [3, "isSecondaryButton", "isIconOnly", "cssClass", "iconClass", "click", 4, "ngIf"], ["pCancelEditableRow", "", 3, "isSecondaryButton", "isIconOnly", "cssClass", "iconClass", "click", 4, "ngIf"], [3, "click", "isSecondaryButton", "isIconOnly", "cssClass", "iconClass"], ["pCancelEditableRow", "", 3, "click", "isSecondaryButton", "isIconOnly", "cssClass", "iconClass"], ["pSaveEditableRow", "", 3, "isSecondaryButton", "isIconOnly", "cssClass", "iconClass", "click", 4, "ngIf"], ["pSaveEditableRow", "", 3, "click", "isSecondaryButton", "isIconOnly", "cssClass", "iconClass"], [3, "click", "cssClass", "isIconOnly", "isSecondaryButton", "iconClass", "disabled"], [3, "colSpan"], ["pTemplate", "footer"], [4, "ngFor", "ngForOf"], [1, "additional-filters-block", 3, "hidden", "ngClass"], ["layout", "horizontal", "styleClass", "mb-0"], [1, "d-flex", "number-of-results-container", 3, "ngClass"], [1, "heading-gray", "mb-0", "text-heading-2"]],
        template: function EzTableTreeComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "p-treeTable", 6, 0);
            i0.ɵɵlistener("onSort", function EzTableTreeComponent_Template_p_treeTable_onSort_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSort($event));
            })("onNodeSelect", function EzTableTreeComponent_Template_p_treeTable_onNodeSelect_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSelectedRow($event));
            })("onColReorder", function EzTableTreeComponent_Template_p_treeTable_onColReorder_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onColReorder($event));
            })("sortFunction", function EzTableTreeComponent_Template_p_treeTable_sortFunction_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.customSort($event));
            })("onLazyLoad", function EzTableTreeComponent_Template_p_treeTable_onLazyLoad_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onLazyLoad($event));
            })("onFilter", function EzTableTreeComponent_Template_p_treeTable_onFilter_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onTableFiltered($event));
            });
            i0.ɵɵtemplate(2, EzTableTreeComponent_ng_template_2_Template, 6, 4, "ng-template", 7)(3, EzTableTreeComponent_ng_template_3_Template, 3, 6, "ng-template", 8)(4, EzTableTreeComponent_ng_template_4_Template, 2, 2, "ng-template", 9)(5, EzTableTreeComponent_5_Template, 1, 0, null, 10)(6, EzTableTreeComponent_ng_template_6_Template, 4, 6, "ng-template", 11)(7, EzTableTreeComponent_ng_template_7_Template, 4, 5, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(9, EzTableTreeComponent_ng_template_9_Template, 2, 5, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("columns", ctx.selectedColumns)("globalFilterFields", ctx._filterColumns)("value", ctx._rows)("dataKey", ctx.keyField)("selectionMode", ctx.selectionMode === "ez-checkbox" ? "checkbox" : ctx.selectionMode)("reorderableColumns", true)("resizableColumns", true)("paginator", ctx.enablePagination)("rowsPerPageOptions", ctx.rowPerPageOptions)("rows", ctx.rowsCount)("customSort", ctx.hasCustomSort)("autoLayout", true)("sortField", ctx.sortField)("sortOrder", ctx.sortOrder)("lazy", ctx.enableLazyLoading)("totalRecords", ctx.totalRecords)("loading", ctx.loading)("styleClass", ctx.tableStyleClass);
            i0.ɵɵattribute("data-cy", ctx.tableNamePrefix);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.showFooter);
          }
        },
        dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2.NgSwitch, i3.NgControlStatus, i3.NgModel, i4.EzSecondaryButtonComponent, i4.EzButtonIconComponent, i4$1.EzCheckboxComponent, i5.PrimeTemplate, i6.ResizableColumn, i6.SaveEditableRow, i6.CancelEditableRow, i7$1.TreeTable, i7$1.TreeTableToggler, i7$1.TTSortableColumn, i7$1.TTSortIcon, i7$1.TTResizableColumn, i7$1.TTRow, i7$1.TTReorderableColumn, i7$1.TTCheckbox, i7$1.TTHeaderCheckbox, i8.Tooltip, i9.MultiSelect, i11.InputText, i12.EzTooltipComponent, i13.Divider, i14.EzSelectOverlayDirective, i14.EzInputWidthByPlaceholderDirective, i15.Select, i18.EzLocalePipe, i19.EzUncamelcasePipe, i19.EzLongToDotsPipe],
        encapsulation: 2
      });
    }
  };
  EzTableTreeComponent = __decorate([UntilDestroy()], EzTableTreeComponent);
  return EzTableTreeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class EzTableActionRequest {}
class EzTableRowReorderModel {}
let EzTableModule = /*#__PURE__*/(() => {
  class EzTableModule {
    static {
      this.ɵfac = function EzTableModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EzTableModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: EzTableModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, EzButtonsModule, EzLocalizationModule, EzCheckboxComponent, InputSwitchModule, TableModule, TreeTableModule, RippleModule, CheckboxModule, TooltipModule, RadioButtonModule, MultiSelectModule, ButtonModule, InputTextModule, DialogModule, ProgressSpinnerModule, SelectButtonModule, EzTooltipComponent, DividerModule, Select]
      });
    }
  }
  return EzTableModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { EzTableActionRequest, EzTableComponent, EzTableModule, EzTableRowReorderModel, EzTableTreeComponent };
